 /*************************************************************************
 *
 * AMIRA CONFIDENTIAL
 * __________________
 *
 *  [2018] - [2019] Amira Learning Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Amira Learning Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Amira Learning Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Amira Learning Incorporated.
 */

import React from 'react';
import {withRouter} from 'react-router';
import Reader from './Reader';
import StoryPicker from './StoryPicker/StoryPicker';
import GradePicker from './StoryPicker/GradePicker';
import GoModal from './GoModal';
import {StudentStatus, studentStatusTypes} from './StudentStatus';
import {ErrorModal, getErrorModalTypes} from './ErrorModal';
import WaitModal from './WaitModal';
import {buildSessionAudio,endUniversalSocketSession,startEDMSession,endEDMSession,isSendingComplete,sendingProgress,getUnconstrainedTranscript,getAudioDuration,setNetworkMonitoringService as setSpeechStreamNetworkMonitoring} from "../../services/SpeechStream";
import { getStoriesByGrade, getStudentMetrics, getUserData, saveAssessmentTiming, calculatePhraseSplits, setSessionActivityId, getStory, endUserSession, setUserData, findFilenames, getUtterance} from "../../services/API";
import { statusType } from "../../services/displayStatus";
import { cleanAndSplit, scoreTranscript, calculateSkipMetrics, setSkipWindow, getSkipWindow } from "../../services/NLP";
import { isPhoneme, wordArrayContainsPhonemes } from "../../services/amirabet";
import { calculateFrameTime } from "../../services/frameTime";
import {getIntervention, preflightIntervention, moveOnWithoutSpeaking} from '../../services/interventionManager';
import { getStoryIntervention, getPageIntervention, getKeepReading, getTryAgain, onPhraseInterventionSelected, resetInterventionHistory } from "../../services/interventionSelection.js";
import studentRecordService from '../../services/StudentRecordService';
import { getStudentReadingLevel, readingLevels, setStudentLevelByGrade, setStudentGradeLevel, getStudentGradeLevel, isStrugglingReader, getWCPMGradePR} from '../../services/readerCharacteristics';
import * as Sentry from '@sentry/browser';
import {logSessionInfo,logSystemData} from "../../services/logger";
import Loading from "../Global/Loading.js";
import {Button, buttonTypes} from '../Global/Button';
import ProgressBubbles from "../Global/ProgressBubbles.js";
import Timeout from 'await-timeout';
import {
  getTextWithPauses,
  calculateAccuracyFromScoredTranscript,
  speakChooseStoryMessage,
  calculateMostRecentScores,
  formatStoryErrorsForScoring,
  calculateAccuracy
} from './ReaderLibrary';
import RepeatAfterMe from '../RepeatAfterMe';
import {
  selectPhraseIntervention,
  resetAIFeaturesForNewStory,
  getPauseTime,
  selectWordIntervention,
  resetWordInterventionTracker,
  trackWordIntervention,
  trackWordInterventionPhraseBoundary,
  getIsInReadWithMeMode,
  setCurrentPhrase,
  setDisabledInterventionTypes,
  addInterventionCountForPhrase,
} from '../../services/aiService';
import {
  wordShouldIntervene,
  isStopWord,
  alreadyIntervened,
  wordDidIntervene,
  getLastPhraseOnPageResponse,
  getReadWithMePrompt,
  speakInterventionLeadIn,
  getTooFastPhrases
} from '../../services/interventionSelection';
import {
  interventionType,
  scopeType,
} from '../../constants/interventionSelectionConstants';
import Quiz from '../Quiz/Quiz';
import {READING_MODES, activityStatus, assignmentTypes, contentTags, phraseTypes, earlyReaderContentTagsNoEdm} from '../../constants/constants';
import yay_image from "../../images/yay.png";
import end_assessment_image from "../../images/end_assessment.svg";
import {getActivityStack,addToActivityStack,removeLastActivityFromStack} from "../App.js";

import silence from "../../images/silence.mp3";

import {COPY_STRINGS} from '../../constants/translatedCopy';

import {isMicAllowed} from '../../services/environment';
import {abortListen} from '../../services/Listen';
import moment from 'moment';
import { getEarlyReaderMode, isEarlyReaderMode } from 'Services/EarlyReaderService';
import { EarlyReaderStatus } from '../Student/EarlyReader/EarlyReaderStatus';
import {clearEarlyReader, flagNewEarlyReader,clearEarlyReaderSequenceStart} from "Services/EarlyReaderService";
import {formatLocale_UpperCaseUnderscore, isSpanishStory} from "Services/locale";
import StruggleMonitor from '../../services/struggle';
import get from 'lodash.get';
import getActivityIntroText from "Services/activityIntroduction";
import { isEarlyReaderStory } from '../../services/EarlyReaderService';
import { updateBatchAssignments } from '../../services/assignment/updateBatchAssignments';
import { skipActivityInManifest } from '../../services/assignment/updateManifest';
import ReaderManagerEvents from './ReaderManagerEvents/ReaderManagerEvents';
import cx from 'classnames'
import { SEGMENT_EVENTS, sendMessageToSqs } from '../../services/segmentService';
import { connect } from 'react-redux';
import { clearEndingSequence, logReaderManagerEvents } from './ReaderManagerEvents/ReaderManagerSlice';
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";
import NetworkMonitoringService, { NetworkStatus } from '../../services/NetworkMonitoringService';
import { updateErssStatus } from '../../services/erssService';
import { getAccessKeyByStudentId } from "../../services/iesAccessKeyService";
import { logSentryException } from '../../services/util';
import { getPhonemePlacementEnabled } from './Speech/Speech';
import { FEATURE_FLAGS } from '../../constants/featureFlags.js';
import { withCurrentStoryWordMetadata } from '../../context/CurrentStoryMetadataContext';
import { RetryNetworkReconnectModal } from './RetryNetworkReconnectModal.js';
import { CriticalNetworkModal } from './CriticalNetworkModal.js';
import { GetBrandedTutorName } from '../../services/BrandingService';
import { getScreeningWindow } from '../../services/screeningWindowService.js';
import {PredictionQuestion} from "amira-intervention-library";
import Interaction from "Components/Interaction/Interaction";
import ReaderManagerEventConstants from './ReaderManagerEvents/ReaderManagerEventConstants.js';
import { shouldEnablePhonemePlacement } from './ReaderManagerUtil.js';
import { setUseGenerativeVoiceGlobal } from '../../services/generativeVoiceService.js';
import StudentInformationService from '../../services/StudentInformationService';

const PromisePool = require('@supercharge/promise-pool');
const unidecode = require('unidecode');

const minPhraseTimes = { //the minimum amount of time to display a phrase. TODO: This should be moved to config and perhaps pulled from the story data itself
  dyslexiaWord: 4000,
  nwf: 5500,
  earlyReaderWord: 2000,
  nonsenseWordRepetition: 7000,
  default: 3000
};
const struggleMonitor = new StruggleMonitor();

let timings = [{time:0, position:0}];
let wav2vecPhonemes = [{time: 0}];
let overallPosition = 0;
let recordingStart = 0;
let lastRecordingStop = 0;
let timeBetweenPages = 0;
let totalTimeSpentIntervening = 0;
let phraseTimeSpentIntervening = 0;
let interventionHoldoffs = 0;
const maxInterventionHoldoffs = 5;
let isWordInterventionInProcess = false;

//Timing
let errordelay = 0;
let lastDelay = 0.0;
let averageDelay = 0;
let phraseDelays = [];
let predictionConfidences = [];
let edmTimeout=null;
let pauseTimerStack=[];
let phraseStartTime = 0;
let stopTime = 0;
let interventionTime = 0;

let handledErrors = false;
let previousOverallPhraseIndex = -1;
let overallPhraseIndex = 0;

let badNetworkNeedsCriticalResponse = false;
let badNetworkInterval;
let badNetworkPauseReadingTimeout;
let badNetworkRetryPauseTimeout;
let badNetworkCriticalTimeout;
let phrasesWithAutoProgressedWords = {};

const relevelTimer = new Timeout();
const assessmentTimer = new Timeout();

//TODO: Move to a placement manager service.
let expectedWord = '';
let struggleType = struggleMonitor.attempts.SUCCEED;
const defaultLastProgress = {transcriptLength: 0};

class ReaderManager extends React.Component {
  constructor (props){
    super(props);

    // Timeout Refs
    this.phraseTimeoutRef = React.createRef();
    this.minTimeTimerRef = React.createRef(); // holds a reference to the timer that will be used to ensure that the minimum amount of time for a phrase to display has elapsed

    this.pauseLength = this.props.config.interventionTimeout;  // pause length in MS.
    this.giveUpLength = this.props.config.giveUpLength;    //this.interventionPauseLength = 6000;  // the amount of time to wait between saying 'mmhmm' and triggering a word intervention if no progress has been made

    this.disableInterventionsForPhrase = false;

    //Utterance constants for pre load
    this.selfAssignedIntro = COPY_STRINGS.amira_intro(GetBrandedTutorName()) + "<break time=\"1.8s\"/> ";
    this.devIntro = "<speak>" + COPY_STRINGS.abbreviated_instructions + "</speak>";
    this.repeatIntro = "<speak>" + COPY_STRINGS.relevel_instructions + "</speak>";

    let sessionData = getUserData();
    this.state = {
      currentPhraseIndex: 0,              // the array index of the phrase currently being read
      currentWordIndex: 0,                // the index of the current word within the current phrase
      errors: [[[]]],                     // an array of the results so far. indexed as follows: errors[page][phrase][word]
      simpleErrors: [[[true]]],           // NOTE populate this with one value to start in case the kid gives no responses at all, so that the graphql call doesnt break
      errorCount: [],                     // The count of errors in each phrase
      interventionWordIndex: -1,          // index of a word to highlight for intervention
      phraseTimes: [[]],                  // amount of time it took the reader to read each phrase
      lastProgress: defaultLastProgress,                   // an object containing the most recent length of the transcript,
                                          // and the time at which the most recent word was recorded. Used to detect pauses
      activityId: sessionData.id,  // activityID populated by 'createActivity' call. This is a placeholder
      modal: null,
      endOfPhrase: false,
      waitingForFinalTranscript: false,
      recommendedStories: null,
      mounted: false,
      pauseLength: this.props.config.mediumReaderPauseTime,  // pause length in MS.
      giveUpLength: this.props.config.giveUpLength,
      matchThreshold: 0.5,
      repeateAfterMeInterventionInProcess: false, //Indicates that the clap aka repeat after me intervention is active
      startReadingTimer: null,
      noAudioTimer: null,
      callbackAfterIntervention: null,
      interveningAtEndOfPage: false,
      wpm: 0,
      wcpm: 0,
      accuracy: 0,
      studentStatusPhrases: [],
      matchTimeout: null,
      testTimeExpired: false,
      recordingID: 0,
      lastWordInterventionIndex: -1,
      prevSkipMetrics: {skipLength: 0, matchLength: 0},
      error: false,
      isFinal: false,
      stylingErrors: [[[]]],
      textResponse: [[[""]]],           // NOTE populate this with one value to start in case the kid gives no responses at all, so that the graphql call doesnt break
      phraseComplete: false, //whether or not the reader has reached the end of the phrase. This is needed because if min time has not elapsed when the reader reaches the end of the phrase, we will wait for minTime to elapse before proceeding
      minTimeElapsed: false, //whether or not the minimum amount of time for the phrase to display has elapsed. TODO: clean up in timer refactor
      pageNavRestrictedTimeout: null,
      pageNavEnabled: false,
      pageNavLastClick: null,
      pageNavTriggered: false,
      frustrationLevelChecked: false,
      storyStarted: false,
      storyInProgress: false,
      storyEnded: false,
      phraseEnded: false,
      detections: null,
      paused: false,
      phraseTimeManagementDisabled: false,
      displayContainer: true,
    };

    this.openStoryPicker = this.openStoryPicker.bind(this);
    this.readAloudWithCallback = this.readAloudWithCallback.bind(this);
    this.openWordInterventionModal = this.openWordInterventionModal.bind(this);
    this.getCurrentWord = this.getCurrentWord.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onPauseDetected = this.onPauseDetected.bind(this);
    this.onLongPauseDetected = this.onLongPauseDetected.bind(this);
    this.onBlankAudioDetected = this.onBlankAudioDetected.bind(this);
    this.onNoStories = this.onNoStories.bind(this);
    this.startListening = this.startListening.bind(this);
    this.setStory = this.setStory.bind(this);
    this.selectStory = this.selectStory.bind(this);
    this.selectGrade = this.selectGrade.bind(this);
    this.openGradePicker = this.openGradePicker.bind(this);
    this.setPlacement = this.setPlacement.bind(this);
    this.setMatchThreshold = this.setMatchThreshold.bind(this);
    this.setPauseLength = this.setPauseLength.bind(this);
    this.setGiveUpLength = this.setGiveUpLength.bind(this);
    this.cleanUpAfterIntervention = this.cleanUpAfterIntervention.bind(this);
    this.readAloudIntent = this.readAloudIntent.bind(this);
    this.returnHome = this.returnHome.bind(this);
    this.displayStudentStatus = this.displayStudentStatus.bind(this);
    this.displayEarlyReaderStatus = this.displayEarlyReaderStatus.bind(this);
    this.onSubmitQuiz = this.onSubmitQuiz.bind(this);
    this.continueReading = this.continueReading.bind(this);
    this.onError = this.onError.bind(this);
    this.handleEndOfAssessment = this.handleEndOfAssessment.bind(this);
    this.handleAbortedAssessment = this.handleAbortedAssessment.bind(this);
    this.updateFrameTime = this.updateFrameTime.bind(this);
    this.onDetectionEnd = this.onDetectionEnd.bind(this);
    this.updateScoring = this.updateScoring.bind(this);
    this.onErrorsAreValid = this.onErrorsAreValid.bind(this);
    this.restartAssignment = this.restartAssignment.bind(this);
    this.phraseStartCallback = this.phraseStartCallback.bind(this);
    this.pausePhrase = this.pausePhrase.bind(this);
    this.resumePhrase = this.resumePhrase.bind(this);
    this.launchNextAssignment = this.launchNextAssignment.bind(this);
    this.onPhraseTimeout = this.onPhraseTimeout.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.resetPhraseTimeout = this.resetPhraseTimeout.bind(this);
    this.startPhraseTimeout = this.startPhraseTimeout.bind(this);
    this.clearPhraseTimeout = this.clearPhraseTimeout.bind(this);
    this.skipWord = this.skipWord.bind(this);
    this.abortIntervention = this.abortIntervention.bind(this);
    this.onInterventionEnd = this.onInterventionEnd.bind(this);
    this.finalizeTutor = this.finalizeTutor.bind(this);
    this.finalizeAssessment = this.finalizeAssessment.bind(this);
    this.checkPageNavEnabled = this.checkPageNavEnabled.bind(this);
    this.onNextPageClick = this.onNextPageClick.bind(this);
    this.calculateWordsCorrect = this.calculateWordsCorrect.bind(this)
    this.isEarlyReader = this.isEarlyReader.bind(this);
    this.handleDefaultPauseDetected = this.handleDefaultPauseDetected.bind(this);
    this.doneHandlingPause = this.doneHandlingPause.bind(this);
    this.startMinTimeTimer = this.startMinTimeTimer.bind(this);
    this.clearMinTimeTimer = this.clearMinTimeTimer.bind(this);
    this.playEndOfPhraseSequence = this.playEndOfPhraseSequence.bind(this);
    this.goToNextPage = this.goToNextPage.bind(this);
    this.advanceOneWord = this.advanceOneWord.bind(this);
    this.setDisableInterventionsForPhrase = this.setDisableInterventionsForPhrase.bind(this);
    this.calculateScoresAndLaunchWordIntervention = this.calculateScoresAndLaunchWordIntervention.bind(this);
    this.onStoryEnd = this.onStoryEnd.bind(this);
    this.getCurrentERSSInterventionTypes = this.getCurrentERSSInterventionTypes.bind(this);
    this.onStoryFetchFailure = this.onStoryFetchFailure.bind(this);
    this.onRecFetchFailure = this.onRecFetchFailure.bind(this);
    this.onPutActivityFailure = this.onPutActivityFailure.bind(this);
    this.handleNetworkStatusChange = this.handleNetworkStatusChange.bind(this);
    this.resumeFromBadNetworkAutoProgress = this.resumeFromBadNetworkAutoProgress.bind(this);
    this.pauseFromBadNetwork = this.pauseFromBadNetwork.bind(this);
    this.resumeFromBadNetworkPause = this.resumeFromBadNetworkPause.bind(this);
    this.handleRetryBadNetworkPauseState = this.handleRetryBadNetworkPauseState.bind(this);
    this.handleBadNetworkCriticalState = this.handleBadNetworkCriticalState.bind(this);
    this.pausePhrase = this.pausePhrase.bind(this);
    this.resumePhrase = this.resumePhrase.bind(this);
    this.getInterventionSelectionV2Params = this.getInterventionSelectionV2Params.bind(this);
  }

  componentDidMount(){
    // expose the read aloud function so that other components can trigger an intervention
    this.props.setInterventions({
      readAloud: this.readAloudWithCallback,
      openWordInterventionModal: this.openWordInterventionModal,
      getCurrentWord: this.getCurrentWord,
    });

    this.loadPotentialUtterances();
    this.setPhraseGrammar(0);

    if(this.props.speech && this.props.speech.resetTranscript){
      this.props.speech.resetTranscript();
    }

    //Make sure we channel the transcript to ReaderManager when it's first mounted
    if(!this.props.isReaderActive){
      this.props.unMuteReader();
    }

    // if we are in forced assessment mode, go straight into the assigned story. Otherwise, open the grade picker
    if(/*this.props.forcedAssessment*/false){ //TODO: this is currently bypassed because we don't have grades from SIS. when we do, use this code
      this.selectStory(this.props.forcedAssessment.storyID);
      // todo this is now redundant with the check inside of `openGradePicker`
    } else if(this.props.asrStoryID && !this.props.preChecksDone){
      try {
        // If asr story id is passed into the props, it is to start the ASR test in Ready Module.
        const callback = () => {
          this.setStory(this.props.asrStoryID);
        };
        this.launchSelfAssignedActivity(this.props.asrStoryID, callback, 'tutor')
      } catch (err) {
        console.log('Error launching self assigned activity.  Returning to home: ', err);
        logSentryException(err, "Error launching self assigned activity.");
        this.onStoryFetchFailure();
      }

    } else {
      this.openGradePicker();
    }

    this.setState({
      mounted: true,
    });

    // Network monitoring
    this.networkMonitoringService = new NetworkMonitoringService(this.handleNetworkStatusChange);
    setSpeechStreamNetworkMonitoring(this.networkMonitoringService);

    if (getUserData().showBadNetworkResponse) {
      // Prefetch bad network pause state speech
      const { locale, bilingualLocale, bilingualMode } = getUserData();
      const inLocale = bilingualMode ? bilingualLocale : locale;
      const includeSpeechMarks = false;
      getUtterance(COPY_STRINGS.paused_from_bad_network_speech, includeSpeechMarks, inLocale);
      getUtterance(COPY_STRINGS.retry_pause_network_speech, includeSpeechMarks, inLocale);
      getUtterance(COPY_STRINGS.resume_from_bad_network_speech, includeSpeechMarks, inLocale);
      getUtterance(COPY_STRINGS.critical_network_speech, includeSpeechMarks, inLocale);
    }
  }

  componentWillUnmount(){
    this.props.speech.abortSpeech();

    //clear all our timeouts
    this.state.startReadingTimer && window.clearTimeout(this.state.startReadingTimer);
    this.state.noAudioTimer && window.clearTimeout(this.state.noAudioTimer);
    this.state.matchTimeout && window.clearTimeout(this.state.matchTimeout);
    edmTimeout && window.clearTimeout(edmTimeout);
    assessmentTimer.clear();
    this.phraseTimeoutRef.current && window.clearTimeout(this.phraseTimeoutRef.current);
    this.state.pageNavRestrictedTimeout && clearTimeout(this.state.pageNavRestrictedTimeout);
    this.minTimeTimerRef.current && window.clearTimeout(this.minTimeTimerRef.current);

    if (badNetworkInterval) {
      window.clearInterval(badNetworkInterval);
    }

    if (badNetworkPauseReadingTimeout) {
      window.clearInterval(badNetworkPauseReadingTimeout);
    }

    if (badNetworkRetryPauseTimeout) {
      window.clearInterval(badNetworkRetryPauseTimeout);
    }

    if (badNetworkCriticalTimeout) {
      window.clearInterval(badNetworkCriticalTimeout);
    }

    //reset all of our local variables which are not stored in state
    // TODO: figure out how to handle this. Perhaps consolodate them into an object and initialize them in the constructor rather than at the top of the file
    this.clearTimingSessionVariables();
    this.clearInterventionTimer();
    this.stopRelevelTimer();
    recordingStart = 0;
    overallPhraseIndex = 0;

    //Timing
    errordelay = 0;
    lastDelay = 0.0;
    averageDelay = 0;
    phraseDelays = [];
    edmTimeout=null;

    if(this.props.history.action === "POP"){
      logSessionInfo("backButtonPushed", { location: this.props.location, history: this.props.history, state: this.state});
      const {pathname} = this.props.location;
      // This line of code will take the user back to the story recommendations instead of the home screen. The reason we don't do it for Early Reader
      //   is that it will simply force the student to restart the activity instead of going back to options, which is confusing for the student.
      if(pathname === "/student/tutor" && this.state.activityId && getUserData().locale === 'en-us' && !this.isEarlyReader()){
        this.props.history.replace('/student/home', {popStateOrigin: '/student/tutor'});
      }
      else if(pathname === "/student/assessment"){
        //endUserSession(); //Bug fix: Leave this in until we can figure out the right way to handle.
      }
    }

    setSpeechStreamNetworkMonitoring(null);
    if (this.networkMonitoringService) {
      this.networkMonitoringService.cleanUp();
    }
  }

  componentDidUpdate(prevProps, prevState){
    this.props.updateWordMetadata(overallPhraseIndex, this.state.currentWordIndex);

    if(this.state.repeateAfterMeInterventionInProcess){
      return;
    }

    // if phoneme placement is enabled for this story type and we just advanced to the next word
    //   of the phrase, check whether we should switch between phoneme mode and blended word mode
    if(this.props.speech.getPhonemePlacementEnabled() && (this.state.currentWordIndex != prevState.currentWordIndex)){
      if(this.shouldListenForPhonemes()){
        this.props.speech.togglePhonemeListeningOn(); //this will do nothing if we're already listening for phonemes
      }
      if(!this.shouldListenForPhonemes()){
        this.props.speech.togglePhonemeListeningOff(); //this will do nothing if we're already using standard placement
      }
    }

    if(this.props.speech.blankRecording && (this.props.speech.blankRecording !== prevProps.speech.blankRecording)){
      this.onBlankAudioDetected(statusType.MUTED);
      this.stopRelevelTimer();
      logSessionInfo("muted",this.props.speech.silentSegments());
    }

    //If we got new phonemes from wav2vec, fire the struggle monitor.
    let forceTranscriptCheck = false;
    if(JSON.stringify(this.props.abPhonemes) !== JSON.stringify(prevProps.abPhonemes) && this.props.speech.isListening){
      forceTranscriptCheck = true;
      this.evaluateStruggle(this.props.abPhonemes.phon);
    }

    //Handle intervention timer when listening
    if(this.props.speech.isListening != prevProps.speech.isListening){
      // Only respond if we are not in pausedFromBadNetwork state
      if (!this.state.pausedFromBadNetwork) {
        this.handleInterventionTimer();
        if (this.networkMonitoringService) {
          const isListening = this.props.speech.isListening;
          if (!isListening) {
            this.networkMonitoringService.setAudioMonitoringActive(false);
          } else if (!isWordInterventionInProcess) {
            // Only turn on audio monitoring if we're not in the middle of a word intervention
            this.networkMonitoringService.setAudioMonitoringActive(true);
          }
        }
      }

    }

    //TODO: figure out how to deal with this mess of conditionals
    if((this.props.transcript && this.props.transcript !== prevProps.transcript) || this.state.testTimeExpired || (this.props.numPhonemes > prevProps.numPhonemes) || forceTranscriptCheck){
      //Only check transcription if we're actively listening. Avoids some race conditions during transitions
      if((((this.props.speech && this.props.speech.isListening)) &&
          (!this.props.modal) && this.props.isReaderActive && !((this.props.transcript.interim == null) && (this.props.transcript.final == null))) ||
          (this.props.numPhonemes > prevProps.numPhonemes) ||
          forceTranscriptCheck){

        if(!this.state.endOfPhrase){
          if(((this.props.numPhonemes > prevProps.numPhonemes) || struggleType === struggleMonitor.Attempt.LOW_EFFECT)&&
            (interventionHoldoffs < maxInterventionHoldoffs) && (this.props.story && this.props.story.type == assignmentTypes.TUTOR)){
            interventionHoldoffs++;
            this.delayInterventionTime();
          }

          this.checkTranscription();
        }
      }
    }

    //if we just loaded speech for the first time, do the initialization
    if(this.props.speech && !prevProps.speech){
      this.props.speech.resetTranscript();
    }

    // if the story has changed, set up a timer to prompt to start reading
    if(this.props.story !== prevProps.story){
      this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_CHANGE, story: this.props.story.title, });
      this.handleStoryChange();
    }

    // if the page has changed, reset everything
    if(this.props.pageIndex !== prevProps.pageIndex){
      this.handlePageChange();
    }

    if(this.state.earlyReaderMode && this.state.earlyReaderMode.readWithMe && this.state.currentPhraseIndex !== prevState.currentPhraseIndex){
      this.repeatAfterMeMode();
    }

    // if the stories have loaded, start preloading audio for the story picker
    if(this.state.recommendedStories !== prevState.recommendedStories){
      this.loadPotentialUtterances();
    }
  }

  isEarlyReader() {
    if(this.props.story) {
      if(isEarlyReaderStory(this.props.story)) {
        return true;
      }
    }
    return false;
  }

  handlePageChange(){
    this.props.speech.setGrammar(this.getCurrentPage()[0]);
    this.setState({
      currentPhraseIndex: 0,
      phraseEnded: false,
      pageNavTriggered: false,
      pageNavRestrictedTimeout: this.setPageNavRestrictedTimeout(),
      pageNavEnabled: false
    }, () => this.props.config.isReadAloud && this.readAloudIntent());
    this.loadPotentialUtterances(); // if we have new phrases, load their read aloud audio
    this.setPhraseGrammar(0);
  }

  handleStoryChange(){
    // reset word intervention history tracking (for intervention selection within the aiService)
    resetWordInterventionTracker();

    if(this.props.story.nonAudio && this.props.speech){
      this.props.speech.stopListening();
    }
    this.setPhraseGrammar(0);

    if(this.props.story){
      this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_START });
      this.onStoryStart();
      resetAIFeaturesForNewStory(this.props.story, this.state.activityId);
      setDisabledInterventionTypes(this.getCurrentERSSInterventionTypes());
    }
  }

  handleInterventionTimer(){
    if(!this.props.speech.isListening){
      this.clearInterventionTimer();
    }

    if(this.state.noAudioTimer){
      window.clearTimeout(this.state.noAudioTimer);
    }
    let audioTimer = null;

    //Set the intervention timer only if we should
    if(this.props.speech.isListening && !this.state.endOfPhrase && !this.props.modal && this.props.isReaderActive){
      this.startInterventionTimer(null);

      //also set a "long pause" timer to detect a defective session.
      audioTimer = window.setTimeout(this.getPauseCheck(null, this.onLongPauseDetected, "compdidupdate").bind(this), 61000);
    }
    this.setState({
      noAudioTimer: audioTimer,
    });
  }

  clearInterventionTimer(){
    this.setState({paused: false});
    interventionTime = 0;
    if(pauseTimerStack.length){
      pauseTimerStack.map((timer)=>{window.clearTimeout(timer)});
    }
    pauseTimerStack=[];
  }

  startInterventionTimer(lastProgress, override=null){
    this.clearInterventionTimer();
    let delayTime = override ? override : this.state.pauseLength;
    interventionTime = Date.now() + delayTime;
    let newTimer = window.setTimeout(this.getPauseCheck(lastProgress, this.onPauseDetected,"startTimer").bind(this), delayTime);
    pauseTimerStack.push(newTimer);
  }

  delayInterventionTime(){
    if(interventionTime){
      let newTime = interventionTime - Date.now() + 1000;
      this.startInterventionTimer(null,newTime);
    }
  }

  clearMinTimeTimer(){
    this.minTimeTimerRef.current && window.clearTimeout(this.minTimeTimerRef.current);
    this.setState({
      minTimeElapsed: false,
    });
  }

  startMinTimeTimer(){
    // TODO: take out this special case and start reading this from the storyDB (phrase item object)
    //        ticket AE-2230
    if(this.props.story.nonAudio){
      this.setState({minTimeElapsed: true});
      return;
    }

    //Clear any active timers
    this.minTimeTimerRef.current && window.clearTimeout(this.minTimeTimerRef.current);

    this.minTimeTimerRef.current = window.setTimeout(() => {
      if(this.state.phraseComplete){
        this.setState({minTimeElapsed: true}, () => {this.onPhraseEnd(this.state.phraseComplete.isRecording)});
      } else {
        this.setState({minTimeElapsed: true});
      }
    }, this.getMinPhraseTime());
    this.setState({minTimeElapsed: false});
  }

  getMinPhraseTime(){
    let minTime = minPhraseTimes.default;

    const item = this.props.story.items ? this.props.story.items[overallPhraseIndex] : null;
    if (item && item.minPhraseTime){
      return this.props.story.items[overallPhraseIndex].minPhraseTime;
    }

    if(item && (item.type === "word" || item.type === "wordPartDeletion" || item.type === "nonsenseWordRepetition" || item.type === "changeOnePart" || item.type === phraseTypes.LETTER_FLIES)){
      if(this.props.story.type === assignmentTypes.NWF){
        minTime = minPhraseTimes.nwf;
      } else if(isEarlyReaderMode(this.state.earlyReaderMode)){
        minTime = minPhraseTimes.earlyReaderWord;
      }else if(item.type === "nonsenseWordRepetition"){
        minTime = minPhraseTimes.nonsenseWordRepetition;
      }else if(this.props.story.type === assignmentTypes.DYSLEXIA){
        minTime = minPhraseTimes.dyslexiaWord;
      }
    }
    return minTime;
  }

  phraseStartCallback(){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.PHRASE_START, overallPhraseIndex: overallPhraseIndex});
    if (this.networkMonitoringService) {
      this.networkMonitoringService.setAudioMonitoringActive(true);
    }

    this.clearInterventionTimer();


    let expectedText = unidecode(this.props.story.phrases[overallPhraseIndex]);
    expectedWord = cleanAndSplit(this.props.story.phrases[overallPhraseIndex])[0];
    let storyTitle = unidecode(this.props.story.title);
    const earlyReaderMode = getEarlyReaderMode(this.props.story);
    this.setState({
      pauseLength: this.getStudentPauseTime(),
      earlyReaderMode: earlyReaderMode,
    });

    if(earlyReaderMode.readWithMe){
      this.repeatAfterMeMode();
    }

    let useReadingTimer = false;
    if(overallPhraseIndex === 0){
      this.setState({storyInProgress: true})
      if(earlyReaderMode && earlyReaderMode.wordList){
        logSessionInfo("early_reader_word_list_story_started", {expandedEarlyReaderEnabled: getUserData().expandedEarlyReaderEnabled});
      }
      let startReadingTimer = null;
      if(!this.props.config.assessmentMode){
        console.log("🔵 startReadingTimer")
        this.state.startReadingTimer && window.clearTimeout(this.state.startReadingTimer);
        startReadingTimer = window.setTimeout((this.onPauseDetected).bind(this,true),10000);
        useReadingTimer = true;
      }
      this.setState({
        startReadingTimer: startReadingTimer,
        pageNavRestrictedTimeout: this.setPageNavRestrictedTimeout(),
        pageNavEnabled: false
      });
      this.props.speech.setLanguage(getUserData().locale);
    }

    setCurrentPhrase(overallPhraseIndex);

    if(this.props.speech && !this.props.story.nonAudio){
      const {phraseId, graphSuffix} = this.buildPhraseId(overallPhraseIndex);
      let recordingProps ={
        phraseIndex: overallPhraseIndex,
        expectedText: expectedText,
        phraseId,
        graphSuffix,
        storyId: this.props.story.storyId,
        storyTags: this.props.story.tags,
        title: storyTitle,
        storyVersion: "1",
        version: "1",
        activityType: this.props.story.type,
        studentId: getUserData().userId,
        flagPhrase: getIsInReadWithMeMode(),
        intervention_data: this.getInterventionSelectionV2Params(),
      }
      if(true){//enableRecording){//TODO: Solve this (only used in ReadToMe). ReadToMe should pass the appropriate enableRecording in the props.
        this.props.speech.enableRecording(recordingProps);
        this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.ENABLE_RECORDING });
        if(recordingStart === 0){
          recordingStart = Date.now();
        }
      }
      if(lastRecordingStop){
        timeBetweenPages += Date.now() - lastRecordingStop;
      }
      phraseStartTime = Date.now();

      // check whether we should be listening for phonemes on the first word of the phrase.
      //  If so, enable phoneme listening mode
      const firstWord = this.getCurrentWord(0);
      if(this.shouldListenForPhonemes(firstWord)){
        this.props.speech.togglePhonemeListeningOn();
      }

      this.props.speech.startListening("phraseStartCallback");
      this.setState({recordingProps: recordingProps}); //Save the props so we can pass them again on a reread.
    }
    this.startInterventionTimer(null,5000);
    interventionHoldoffs = 0;
    this.startMinTimeTimer();

    this.props.speech.resetTranscript();

    this.resetPhraseTimeout(true,useReadingTimer); //NOTE: do this here instead of in getPhraseTimeout so that we can consolidate rerenders
  }

  /**
   * clears timers and timeouts
   */
  pausePhrase(){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.PHRASE_PAUSE, overallPhraseIndex: overallPhraseIndex});
    console.log("🔴 pausePhrase")
    this.clearInterventionTimer();
    this.clearMinTimeTimer();
    this.clearPhraseTimeout();
  }

  /**
   * restarts timers and timeouts as if they were just started
   */
  resumePhrase(){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.PHRASE_RESUME, overallPhraseIndex: overallPhraseIndex});
    this.startInterventionTimer(null,5000);
    this.startMinTimeTimer();
    this.resetPhraseTimeout();
  }


  setDisableInterventionsForPhrase(disableInterventionsForPhrase){
    this.disableInterventionsForPhrase = disableInterventionsForPhrase;
  }

  loadPotentialUtterances(){
    //Keep here for a day where we do optimize for this
  }

  startPhraseTimeout(){
    this.phraseTimeoutRef.current && window.clearTimeout(this.phraseTimeoutRef.current);

    if(this.props.story && this.props.story.items && this.props.story.items[overallPhraseIndex] && this.props.story.items[overallPhraseIndex].timeoutInMS){
      this.phraseTimeoutRef.current = window.setTimeout(this.onPhraseTimeout,this.props.story.items[overallPhraseIndex].timeoutInMS);
    } else {
      this.phraseTimeoutRef.current = null;
    }
  }

  clearPhraseTimeout(startOfPhrase=false){
    console.log("🟡 clearPhraseTimeout")
    this.phraseTimeoutRef.current && window.clearTimeout(this.phraseTimeoutRef.current);
    this.state.startReadingTimer && window.clearTimeout(this.state.startReadingTimer);
    // If we're at the start of the phrase, we have just set the startReadingTimer so it won't be in state
    // Nulling it here not only causes it to never get cancelled, it causes it to never really fire.
    if(!startOfPhrase){
      this.setState({startReadingTimer: null});
    }
  }

  resetPhraseTimeout(startOfPhrase=false,enableStartReading=true){ //NOTE: only use this in situations where you are not making another call to setState
    this.clearPhraseTimeout(startOfPhrase);
    if(this.state.startReadingTimer && enableStartReading){
      console.log("🔵 startReadingTimer")
      let startReadingTimer = window.setTimeout((this.onPauseDetected).bind(this,true),10000);
      this.setState({
        startReadingTimer: startReadingTimer,
      });
    }else{
      console.log("🟢 resetPhraseTimeout")
      this.startPhraseTimeout();
    }
  }

  /**
   * resets reader manager states related to pauses
   */
  doneHandlingPause(){
    this.setState({
      firstPass: false,
      paused: false,
    })
  }

  // these getters and setters are necessary because of the multi layered array structure used for tracking errors and timers by page and phrase
  getCurrentPhraseScore(){
    if(this.state.errors[this.props.pageIndex] && this.state.errors[this.props.pageIndex][this.state.currentPhraseIndex]){
      return  this.state.errors[this.props.pageIndex][this.state.currentPhraseIndex];
    } else {
      return {};
    }
  }

  //Clean and split the gurrent phrase errors to pass to the intervention selection
  // and add the index pf the error into the original array so that we can
  // correct the word if doing the clap intervention.
  getWordErrors(inErrors=null){
    let phrase = this.getCurrentPage()[this.state.currentPhraseIndex];
    phrase = cleanAndSplit(phrase);
    let errors = inErrors ? inErrors : this.getCurrentPhraseErrors();
    let wordErrors = [];

    for(let i=0;i<phrase.length;i++){
      if(errors[i]) wordErrors.push({word: phrase[i],index: i});
    }
    return wordErrors;
  }

  //TODO: Hacked so we always show everything correct while the student is reading.
  // If this sticks, will remove the old method but wanted to preserve it.
  setCurrentPhraseScore(score,endOfPhrase){
    //TODO: HACK allow EDM to opt out of styling
    let currentErrors = this.state.errors;
    let currentPageErrors = currentErrors[this.props.pageIndex] || [];
    currentPageErrors[this.state.currentPhraseIndex] = score;
    currentErrors[this.props.pageIndex] = currentPageErrors;

    //Handle the styling array
    // The logic here is: If an error is set, do not allow subsequent updates to clear it.
    let currentStylingErrors = this.state.stylingErrors;
    let currentStylingPageErrors = currentStylingErrors[this.props.pageIndex] || [];

    //Save the current state of styling errors
    const currentState = currentStylingPageErrors[this.state.currentPhraseIndex] ? currentStylingPageErrors[this.state.currentPhraseIndex].totalErrors : [];

    //Then update with the new errors
    let newErrors = JSON.parse(JSON.stringify(score));

    //Then re-set any errors that existed before we updated the array.
    //###Hack to turn everything green.
    if(currentState && !endOfPhrase){
      /*for(let i=0;i<currentState.length;i++){
        if(currentState[i]){
          newErrors.totalErrors[i] = true;
        }*/
      for(let i=0;i<newErrors.totalErrors.length;i++){
        //newErrors.totalErrors[i] = newErrors.skips[i];
        newErrors.totalErrors[i] = false;
      }
    }

    currentStylingPageErrors[this.state.currentPhraseIndex] = newErrors;
    currentStylingErrors[this.props.pageIndex] = currentStylingPageErrors;

    this.setState({
      stylingErrors: currentStylingErrors,
      errors: currentErrors,
      currentWordIndex: score.totalErrors.length
    });

    return currentErrors;
  }

  getCurrentPhraseErrors(){
    let currentPhraseScore = this.getCurrentPhraseScore();
    return Array.isArray(currentPhraseScore.totalErrors) ? currentPhraseScore.totalErrors : [];
  }

  setCurrentPhraseErrors(errors,endOfPhrase=false){
    let currentScore = this.getCurrentPhraseScore();
    let cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
    //Make sure we're never writing more than the current phrase length
    try{
      if(errors && Array.isArray(errors)){
        currentScore.totalErrors = errors.slice(0,cleanPhrase.length);
      }else{
        currentScore.totalErrors = errors;
      }

    }catch(e){
      logSentryException(e, "Error setting current phrase errors");
      currentScore.totalErrors = errors;
    }

    return this.setCurrentPhraseScore(currentScore,endOfPhrase);

  }

  openModal(content, props={}){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.OPEN_MODAL, modalName: props.logName });
    if(!this.state.error){
      this.setState({
        displayContainer: !props.hideReaderContainer
      });
      this.props.openModal(content, props);
    }
  }

  openModalAndStopListening(content, props={}){
    this.props.speech.stopListening("openModalAndStopListening");
    this.openModal(content,{...props, logName: "openModalAndStopListening"});
  }

  handleMessage(message) {
    try {
      let messageCallback = message.endOfPhrase ? this.cleanUpAfterIntervention : this.onInterventionEnd;

      if(!message){
        messageCallback();
        return;
      }

      // Attach a callback function to the message if none provided
      if(!message["callback"]){
        message["callback"] = messageCallback;
      }
      if(message.listen){
        message.listen();
      }
      if(message.text){
        this.props.sendMessage(message);
      }
      if(message.speakFunction){
        message.speakFunction(message.callback || messageCallback);
      }
      if(message.continueWithoutSpeaking){
        if(message.endOfPhrase){
          this.closeModal();
          this.cleanUpAfterIntervention();
        }else{
          this.onInterventionEnd();
        }
      }
    } catch(err) {
      console.log("ERROR IN WORD INTERVENTION -- HANDLE MESSAGE",err);
      logSessionInfo(err.name + " " + err.message,{error: err.stack});
      logSentryException(err, "Error in word intervention -- handle message");
      this.abortIntervention();
    }
  }

  onInterventionEnd(){
    let timeSpentIntervening =  this.state.interventionStartTime ? Date.now() - this.state.interventionStartTime : 0;
    phraseTimeSpentIntervening+=timeSpentIntervening;
    isWordInterventionInProcess = false;
    this.setState({
      interventionStartTime: 0,
      repeateAfterMeInterventionInProcess: false,
      interventionWordIndex: -1,
      interventionWord: null,
    });
    this.doneHandlingPause();
    this.closeModal(true);
    if (this.networkMonitoringService) {
      this.networkMonitoringService.setAudioMonitoringActive(true);
    }
  }

  // open up a Modal and send the message to the coach
  // TODO: Rename/rethink this
  openWordInterventionModal({modal,message,closeButton,delayedCloseButton=true,hideBackground,hideReaderContainer}){
    logSessionInfo("modalOpened",{modal: modal,message: message});
    if(modal){
      try{
        this.openModalAndStopListening(modal, {
          closeButton: closeButton,
          delayedCloseButton: delayedCloseButton,
          close: this.abortIntervention.bind(this),
          key:"intervention",
          hideBackground,
          hideReaderContainer,
        });
        this.setState({interventionStartTime: Date.now()});
      }catch(err){
        console.log("ERROR IN WORD INTERVENTION -- OPEN MODAL FAILED",err);
        logSessionInfo(err.name + " " + err.message,{error: err.stack});
        logSentryException(err, "Error in word intervention -- open modal failed");
        this.abortIntervention();
        return;
      }
    }

    if(message){
      this.handleMessage(message);
    }
  }

  continueReading(){
    logSessionInfo("modalClosedInContinue_"+this.state.lastIntervention,{word: this.getCurrentWord().trim(), type: this.state.lastIntervention, index: this.state.currentWordIndex});
    if(this.state.matchTimeout) window.clearTimeout(this.state.matchTimeout);
    this.setState({matchTimeout: null});
    this.props.speech.cancelMatchRequest();
    this.props.closeModal();
    let textToSpeak = this.state.interveningAtEndOfPage ? getLastPhraseOnPageResponse() : getKeepReading(getStudentReadingLevel());
    this.setState({interveningAtEndOfPage: false});
    let prompt={
      textToSpeak: textToSpeak,
      onEnd: this.cleanUpAfterIntervention.bind(this),
    }
    this.props.speech.speak(prompt,true); //TODO: Re-evaluate/watch this - not sure I like forcing listen here.
  }

  async launchInteraction() {
    const phraseMetadata = this.getCurrentPhraseMetaData();
    await new Promise(resolve => {
      this.setState({
        readerScreenContentOverride: (
          <Interaction
            speech={this.props.speech}
            onDone={() => {
              this.setState({
                readerScreenContentOverride: null
              });
              resolve();
            }}
            interactions={phraseMetadata.interactions}
            phraseIndex={overallPhraseIndex}
            storyId={this.props.story.storyId}
            activityId={this.state.activityId}
            showFTUE={!getUserData().hasSeenDialogFTUE || this.props.forceDialogFTUE}
            onFinishFTUE={() => StudentInformationService.setDialogFTUESeen(getUserData().userId, true)}
          />
        ),
      })
    })
  }

  //TODO: Move all the conditional down into InterventionSelect - Pete note: conditionally, depending on good separation of concerns.
  async launchWordIntervention(inWord, mostRecentScores, endOfPhrase=false, intervention=null, forceSkip = false){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.INTERVENTION_ON_WORD });
    let didIntervene = true;
    let lastWordInterventionIndex = this.state.lastWordInterventionIndex;
    let intervenedOnLastWord = false;
    isWordInterventionInProcess = true;

    //If the intervention selection logic chose an intervention on a word we don't want, override it with skipword
    if(forceSkip || isStopWord(inWord) || ((overallPhraseIndex == 0 && this.state.currentWordIndex == 0) && !isEarlyReaderMode(this.state.earlyReaderMode)) || inWord.length < 3){
      //Only call skipWord if we're not at end of phrase or bad things will happen.
      if(!endOfPhrase){
        if((forceSkip || inWord.length < 3) || isStopWord(inWord)) {
          this.skipWord(false);
        } else {
          this.skipWord();
        }
        lastWordInterventionIndex = this.state.currentWordIndex;

        // We want to count give word or skip word interventions for the purposes of counting how often user needed intervening
        addInterventionCountForPhrase(overallPhraseIndex);
      }else{
        didIntervene = false;
      }

    } else if(!intervention || (intervention.type !== interventionType.none)){
      try{
        const cleanInterventionWord = this.getCurrentWord(this.state.currentWordIndex, true);
        let chosenIntervention = await selectWordIntervention(cleanInterventionWord,intervention, this.state.currentWordIndex, this.props.forceIntervention);
        this.setState({lastIntervention: chosenIntervention.type});

        if (
          chosenIntervention.type !== interventionType.skip &&
          chosenIntervention.type !== interventionType.giveword &&
          chosenIntervention.type !== interventionType.none) {
          if (this.networkMonitoringService) {
            this.networkMonitoringService.setAudioMonitoringActive(false);
          }
        }

        if (chosenIntervention.type === interventionType.clap) {
          const wordToUse = cleanInterventionWord.replace(/[.,\/#!$%\^&\*;:{}=\-_`'~()""?!]/g, "");
          this.playRepeatAfterMe(wordToUse, this.state.currentWordIndex);
        } else {
          getIntervention({
            speech: this.props.speech,
            inWord: inWord,
            callback: this.openWordInterventionModal,
            endOfPhrase: endOfPhrase,
            chosenIntervention: chosenIntervention,
            currentWordIndex: this.state.currentWordIndex,
            handleMessage: this.handleMessage,
            skipWord: this.skipWord,
            phraseMeta: this.getCurrentPhraseMetaData(),
            mostRecentScores:  mostRecentScores,
          });
        }
      }catch(err){
        console.log("ERROR IN WORD INTERVENTION",err);
        logSessionInfo(err.name + " " + err.message,{error: err.stack});
        logSentryException(err, "Error in word intervention");
        didIntervene = false;
      }

      lastWordInterventionIndex = this.state.currentWordIndex;

      //If we're intervening on the last word of a phrase
      if(lastWordInterventionIndex >= cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]).length-1){
        intervenedOnLastWord = true;
      }
    } else{
       if(endOfPhrase){
         this.cleanUpAfterIntervention();
       }
    }
    if(!endOfPhrase && didIntervene && !this.state.endOfPhrase){
      this.setStoryIntervention();
    }

    this.setState({
      lastProgress: defaultLastProgress,
      lastWordInterventionIndex,
      intervenedOnLastWord,
    });

    if (!didIntervene) {
      isWordInterventionInProcess = false;
    }

    return Promise.resolve(didIntervene);
  }

  setStoryIntervention(){
    let {storyInterventions} = this.state;
    if(this.state.currentWordIndex < storyInterventions[overallPhraseIndex].length){
      storyInterventions[overallPhraseIndex][this.state.currentWordIndex] = true;
      this.setState(storyInterventions)
    }
  }

  //If a phrase timeout was specified, call PhraseEnd if it expires
  onPhraseTimeout(){

    //If we're on the first page of a dyslexia test and the cursor has not moved, terminate the test
    //If there is only one word in the phrase, don't fire muted.
    let currentPhraseLength = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]).length;
    if((this.props.pageIndex == 0) && !this.props.story.nonAudio && !this.props.orfMode && (this.state.currentWordIndex === 0) && (currentPhraseLength > 1)){
      this.onBlankAudioDetected(statusType.STUCK_PLACEMENT);
      logSessionInfo("stuck_placement_manager",this.props.speech.silentSegments());
    }else{
      this.onPhraseEnd(this.props.speech.isRecording());
    }
  }

  // this will contain the original onPauseDetected code
  // pass it down to Phrase, and let the Phrase decide if it should call this default handler
  // or it should not do it and let the Phrase item component handle it
  handleDefaultPauseDetected(){
    //Don't intervene on the very first word of a story. Just say "please start reading". This will happen even when other word interventions are disabled.

    //Temporarily disable the whole start reading thing. TODO: This whole timer needs to be either removed or we need to implement this in a way that doesn't wreak havoc.
    if(false && overallPhraseIndex === 0){
      if((!this.props.story.nonAudio) && (this.state.firstPass && (this.props.orfMode || isEarlyReaderMode(this.state.earlyReaderMode)) || this.state.startReadingTimer)){
        let props = {};
        //### DISABLE FOR NOW props.textToSpeak = COPY_STRINGS.start_reading;
        //### DISABLE FOR NOW this.props.speech.speak(props);
        this.setState({
          startReadingTimer: null,
        }, this.resetPhraseTimeout(false,false))
        return;
      }
    }

    //If all of the above checks fail but this is the first pass, do not do interventions (this is the please start reading timer)
    if(this.state.firstPass){
      return;
    }

    // if this is within the last two words of the final phrase of the page in assessment mode then we should turn the page
    // this will keep kids from getting stuck if they are having trouble getting their speech recognized in the final words of the page
    // TODO: remove when we do away with assessment pagination (in tutor mode this is taken care of by the "skip word" intervention)
    let phrases = this.getCurrentPage();
    let currentPhraseLength = phrases[this.state.currentPhraseIndex];
    if(currentPhraseLength){
      currentPhraseLength = currentPhraseLength.split(" ").length;
    }else{
      return;
    }

    if(this.props.config.assessmentMode && this.props.orfMode && !getUserData().assessmentPageNavEnabled || this.disableInterventionsForPhrase){ // put this.disableInterventionsForPhrase here instead of in the below if to keep from getting stuck
      this.skipWord(false); //We are always recording in assessment mode
      return;
    }

    //Disable Word Interventions
    if(this.props.config.disableWordInterventions || !this.props.config.enableInterventions){
      return;
    }

    let currentWord = this.findWordToIntervene();
    if(this.props.speech && this.props.speech.isListening && currentWord){
      // Track which words have fired word-level interventions (regardless of whether they've triggered an intervention selection event)
      trackWordIntervention(this.state.currentWordIndex);

      // Launch the word intervention (which will move the cursor on stopWords, short words, and first words in a phrase)
      //Temporarily choose to downgrade to moving the cursor half the time if it's a Spanish story
      let skipIntervention = false;
      if(isSpanishStory(this.props.story) && Math.random() < 0.17){
        skipIntervention = true;
      }

      this.calculateScoresAndLaunchWordIntervention({word: currentWord, skipIntervention});
    } else {
      this.setState({
        lastProgress: defaultLastProgress,
      });
    }
    return true // notify the caller that an intervention will be launched
  }

  calculateScoresAndLaunchWordIntervention({word, skipIntervention=false}){
    const mostRecentScores = calculateMostRecentScores(this.state.errors, getAudioDuration());
    this.launchWordIntervention(word,mostRecentScores,this.state.endOfPhrase,null,skipIntervention).then((success) => {
      if(!success){
        this.skipWord(false);
      }
    }, (err) => {
      console.log("ERROR LAUNCHING WORD INTERVENTION:",err);
      logSessionInfo(err.name + " " + err.message,{error: err.stack});
      logSentryException(err, "Error launching word intervention");
      this.skipWord(false);
    });
  }

  //This essentially just wraps launch so that it can get launched asynchronously
  //  and we select the current word. This is the callback that gets triggered by
  //  the timer.
  onPauseDetected(firstPass=false){
    this.setState({
      firstPass: firstPass,
      paused: true,
    })
  }

  refreshBrowser(){
    endUserSession();
  }

  // When we have blank audio (note: different from muted)
  onBlankAudioDetected(status){
    return studentRecordService.markAbortedKeepingAssignment(this.state.activityId,status)
    .then(()=>{
      this.openModalAndStopListening(
        <ErrorModal
          type={getErrorModalTypes().BLANK}
          speech={this.props.speech}
          continue={this.refreshBrowser}
        />
      );
    });
  }

  onNoStories(){
    return this.markForcedAssessmentComplete(this.state.activityId,status)
    .then(()=>{
      this.openModalAndStopListening(
        <ErrorModal
          type={getErrorModalTypes().NOSTORIES}
          speech={this.props.speech}
          continue={this.refreshBrowser}
        />
      );
    });
  }

  calculateWordsCorrect(){
    return this.getCurrentPhraseErrors().reduce((total,error)=>{
      return error ? total : total+1;
    },0);
  }

  //Start timer to check relevel. Simplified logic is to check student's progress after a minute and downlevel if they're not 8 words in.
  startRelevelTimer(){
    relevelTimer.set(60000)
    .then(()=>{
      if(this.props.config.assessmentMode && (this.props.pageIndex == 0) && this.props.orfMode){
        let studentGrade = getUserData().actualGrade;
        let storyGrade = parseInt(this.props.story.grade);
        let errors = this.getCurrentPhraseErrors();
        let wordsCorrect = errors.reduce((total,error)=>{
          return error ? total : total+1;
        },0);

        logSessionInfo('downlevel_check', {
          src: 'relevelTimer',
          wordsCorrect,
          errors: this.state.errors,
          currentPhraseErrors: errors,
          studentGrade,
          storyGrade,
        });

        //downlevel if the student has not read 8 words
        //and the student has not upleveled
        if(wordsCorrect < 8 && storyGrade <= studentGrade){
          logSessionInfo('downlevel', {
            src: 'relevelTimer',
            wordsCorrect,
            errors: this.state.errors,
            currentPhraseErrors: errors,
            studentGrade,
            storyGrade,
          });
          this.reLevel("long_pause");
        }
        else{
          let {wcpm} = calculateMostRecentScores(this.state.errors, getAudioDuration());
          const locale = isSpanishStory(this.props.story) ? "es-mx" : "en-us";
          let wcpmPR = getWCPMGradePR(wcpm, this.props.story.grade, locale);

          logSessionInfo('uplevel_check', {
            src: 'relevelTimer',
            errors,
            wcpm,
            wcpmPR,
            locale,
          });

          //up level story if the student's wcpm is above 95% of the PR for the story's grade
          //and the student has not been downleveled
          if(wcpmPR >= 95 && storyGrade >= studentGrade && storyGrade < 6){
            logSessionInfo('uplevel', {
              src: 'relevelTimer',
              errors,
              wcpm,
              wcpmPR,
              locale,
            });
            this.reLevel("above_grade_level");
          }
        }
      }
    })
  }

  stopRelevelTimer(){
    relevelTimer.clear();
  }

  // when the studnet has made no progress for 60 seconds, if we're on the first page, relevel the assessment. Otherwise, throw up the error modal
  onLongPauseDetected(){
    if(this.props.asrStoryID) return;
    if(this.props.config.assessmentMode){
      return;
    }
    console.log("HERE",overallPhraseIndex)
    if(overallPhraseIndex === 0){
      logSessionInfo("longpause_firstword", { location: this.props.location, history: this.props.history, state: this.state, speech: this.props.speech.getSpeechState()});
      this.openModalAndStopListening(
        <ErrorModal
          type={getErrorModalTypes().AUDIO}
          speech={this.props.speech}
          continue={this.restartAssignment}
        />
      );
    }
  }

  async reLevel(src=null){
    logSessionInfo("placement_logs",timings);

    const downLevel = (src === null || ["long_pause", "frustration_error_count"].includes(src));
    const upLevel = (src === "above_grade_level");

    if(downLevel && getStudentGradeLevel(true) <= 0){
      await flagNewEarlyReader(getUserData().userId,getUserData().locale);
      this.handleEndOfAssessment(statusType.PREREADER);
    }
    else {
      let status = downLevel ? statusType.DOWNLEVELED : (upLevel ? statusType.UPLEVELED : statusType.DOWNLEVELED);
      studentRecordService.markAborted(this.state.activityId,status)
      .then((response) => {
        let props = {};
        props.textToSpeak = COPY_STRINGS.try_different_story;
        props.onEnd = () => {
          this.handleAbortedAssessment(src).then(() => {
            let currentGrade = parseInt(this.props.story.grade);
            let newGrade = downLevel ? currentGrade - 1 : currentGrade + 1
            setStudentGradeLevel(newGrade);
            this.restartAssignment();
          });
        }
        this.props.speech.speak(props);
      });
    }
  }

  getInterventionSelectionV2Params() {
    const { errorCount, errorRate } = calculateMostRecentScores(this.state.errors);

    let overrideWCPM;
    let overrideARM;

    let overrideGrade = parseInt(this.props.forceInterventionSelectionGrade);
    overrideGrade = !isNaN(overrideGrade) ? overrideGrade : undefined;

    if (overrideGrade !== undefined) {
      switch (overrideGrade) {
        case 0:
          overrideWCPM = 16.5;
          break;
        case 1:
          overrideWCPM = 27.1;
          break;
        case 2:
          overrideWCPM = 73.8;
          break;
        case 3:
          overrideWCPM = 86.2;
          break;
        case 4:
          overrideWCPM = 90.3;
          break;
        case 5:
          overrideWCPM = 113.3;
          break;
        case 6:
          overrideWCPM = 128;
          break;
      }

      overrideARM = overrideGrade + 0.4;
    }

    let forceInterventionSelectionWCPM = parseInt(this.props.forceInterventionSelectionWCPM);
    forceInterventionSelectionWCPM = !isNaN(forceInterventionSelectionWCPM) ? forceInterventionSelectionWCPM : undefined;

    if (forceInterventionSelectionWCPM) {
      overrideWCPM = forceInterventionSelectionWCPM;
    }

    let forceInterventionSelectionARM = parseFloat(this.props.forceInterventionSelectionARM);
    forceInterventionSelectionARM = !isNaN(forceInterventionSelectionARM) ? forceInterventionSelectionARM : undefined;

    if (forceInterventionSelectionARM) {
      overrideARM = forceInterventionSelectionARM;
    }

    const interventionSelectionParams = {
      isESL: getUserData().isESL ? true : false,
      grade: getUserData().actualGrade,
      prev_equatedwcpm: overrideWCPM ?? getUserData().interventionSelectionWCPMScore,
      prev_arm_estimate: overrideARM ?? getUserData().interventionSelectionARMScore,
      error_count: errorCount,
      error_rate: errorRate,
    };

    let screeningWindow;
    const windowString = getScreeningWindow();
    if (windowString) {
      switch (windowString) {
        case "BOY":
          screeningWindow = 0;
          break;
        case "MOY":
          screeningWindow = 1;
          break;
        case "EOY":
          screeningWindow = 2;
          break;
      }
    }

    if (screeningWindow !== undefined) {
      interventionSelectionParams.window = screeningWindow;
    }

    return interventionSelectionParams;
  }

  launchNextAssignment(){
    // the order of these two call matters, don't move them unless you know what you are doing.
    this.props.nextAssignment();
    this.props.resetStory();
  }

  // TODO: make this work well with tutor (resetting back to the old story selection and skipping grade picker)
  // for now this will work as expected for assessment but will make tutor go back through story selection process
  restartAssignment(){
    // remove the most recent assignment (the one which was downleveled) from the list of "completed" assignments,
    //    and make it a failed parent in the chain instead
    this.props.setMidAssessment();
    let failedActivityId = removeLastActivityFromStack();
    this.props.setParentActivityId(failedActivityId);
    this.props.resetStory();
  }

  advanceOneWord() {
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.WORD_INCREMENT });
    let phraseErrors = this.getCurrentPhraseErrors() || [];
    phraseErrors.push(true);
    setSkipWindow(getSkipWindow() + 1);

    this.setCurrentPhraseErrors(phraseErrors);

    this.setState({
      lastProgress: defaultLastProgress,
    });

    // Checek whether we should advance to the next phrase
    let cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
    if(phraseErrors.length >= cleanPhrase.length){
      //we just skipped the last word
      this.props.speech.stopListening();
      let isRecording = this.props.speech.isRecording();

      // Account for stop words, etc.
      for(let i=0; i<cleanPhrase.length; i++){
        phraseErrors[i] = this.finalizeError(cleanPhrase[i],phraseErrors[i]);
      }
      this.setCurrentPhraseErrors(phraseErrors);
      if(!this.state.endOfPhrase){
        this.handlePotentialEndOfPhrase();
      }

      this.clearInterventionTimer();
      this.onPhraseEnd(isRecording);
    }
  }

  skipWord(sayWord=true, force=false, noError=false){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.WORD_SKIP });
    this.doneHandlingPause();

    //Don't ever advance on the first word of a story, unless we have manually passed a param in to
    //  force it. Right now we are using 'force' for our early reader activities because we want to be
    //  able to manually move the pre-reader forward as necessary
    if((this.state.currentWordIndex == 0) && (this.props.pageIndex == 0) && (this.state.currentPhraseIndex == 0) && !force) return;

    //Don't read if we're not listening.
    if((this.props.speech.isListening == false) && sayWord) return;

    let isRecording = this.props.speech.isRecording();
    let currentWord = this.getCurrentWord(this.state.currentWordIndex, true).trim();
    this.setState({lastIntervention: interventionType.skip});
    wordDidIntervene({word: currentWord, type: interventionType.skip, index: this.state.currentWordIndex});
    let props = {};
    props.textToSpeak = currentWord;
    props.skipTranslation = true;

    //Keep track of time we're not listening
    props.onEnd = ((startTime,isRecording,sayWord) => {
      let timeSpentIntervening = Date.now() - startTime;
      phraseTimeSpentIntervening += timeSpentIntervening;

      let phraseErrors = this.getCurrentPhraseErrors() || [];
      phraseErrors.push(noError ? false : true);

      this.setCurrentPhraseErrors(phraseErrors);

      this.setState({
        lastProgress: defaultLastProgress,
      });

      // Widen out the single-match window
      // This is necessary because the skip intervention is moving the cursor forward and
      // as far as our diff algorithm is concerned any words uttered after this will look like
      // a skip, which will require multiple words to match unless we do this.
      // TODO: Re-evaluate this solution for this problem and look at directly modifying the transcript
      //       OR factoring the errors into the scoreTranscript.
      setSkipWindow(getSkipWindow() + 1);

      let cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
      if(phraseErrors.length >= cleanPhrase.length){
        //we just skipped the last word
        this.props.speech.stopListening();

        // Account for stop words, etc.
        for(let i=0; i<cleanPhrase.length; i++){
          phraseErrors[i] = this.finalizeError(cleanPhrase[i],phraseErrors[i]);
        }
        this.setCurrentPhraseErrors(phraseErrors);
        if(!this.state.endOfPhrase){
          this.handlePotentialEndOfPhrase();
        }

        this.clearInterventionTimer();
        this.onPhraseEnd(isRecording);
      }else{
        if(!sayWord){
          this.startInterventionTimer(null);
        }
        if (this.networkMonitoringService) {
          // Turn on network audio monitoring after skip word if we are not at end of phrase
          this.networkMonitoringService.setAudioMonitoringActive(true);
        }
      }
      isWordInterventionInProcess = false;
    }).bind(this,Date.now(),sayWord ? isRecording:true,sayWord);

    if(sayWord){
      this.props.speech.speak(props);
    }else{
      window.setTimeout(props.onEnd,5);
    }
  }

  /** LOCAL INTERVENTION HANDLER **/
  // reads the current phrase aloud, highlighting the text in the passage to go along with the synthesized voice
  // when finished, updates the phrase index to move on to next phrase
  readAloudWithCallback(callback=null, readSlowly=true){
    let text = this.getCurrentPage()[this.state.currentPhraseIndex];

    if(text){
      let props = {};

      // stop listening when we start speaking
      props.onStart = ((event) => {
        this.props.speech.stopListening();
      });

      // start listening again, reset the interventionWordIndex so that we are no
      // longer highlighting words in the passage, and advance the phrase index
      props.onEnd= ((callback) => {
        this.setState({
          interventionWordIndex: -1,
        });
        if(callback){
          window.setTimeout(callback, 10);
        } else {
          if (!this.props.config.isNotInteractive) {
            this.startListening("readAloudWithCallback");
          }
        }
      }).bind(this,callback);

      // when we encounter a word boundary, highlight the currently spoken word
      // calculate the index of the highlighted word using the provided charIndex
      props.onBoundary = ((word) =>
        this.setState({
          interventionWordIndex: word.start,
        })
      );

      props.textToSpeak = getTextWithPauses(text, this.props.config, this.getCurrentPhraseErrors() || []);
      if(readSlowly) {
        props.textToSpeak = "<prosody rate=\"slow\"> " + props.textToSpeak  + " </prosody>"
      }
      props.skipAvatar = false;
      props.skipTranslation = true;
      props.returnSpeechMarks = true;
      props.passThroughSpeechTags = true;
      this.props.speech.speak(props);
    }
  }

  readWithMe(){
    //TODO: embed this logic in `nextPhrase`. this will require a rework of existing logic
    if(this.state.currentPhraseIndex == (this.props.story.pages[this.props.pageIndex].length - 1)){//If Last Phrase
      if(this.props.pageIndex >= (this.props.story.pages.length - 1)){//If Last Page
        this.cleanUpAfterIntervention();
        return;
      }else{
        this.nextPhrase();
        this.props.goToNextPage();
      }
    }else {
      this.nextPhrase(this.props.speech.stopListening, false);
    }


    let callback = () => {
      this.tryAgain(getReadWithMePrompt(),false);
    }
    this.readAloudWithCallback(callback, true); // read aloud slowly
  }

  repeatAfterMeMode(){
    let callback = () => {
      //TODO: should this use tryAgain, a different function or a new function?
      this.tryAgain(null, false, false);
    }
    this.readAloudWithCallback(callback, true); // read aloud slowly
  }

  endReadWithMeMode(){
    this.props.speech.speak({textToSpeak: COPY_STRINGS.end_read_with_me_mode});
    this.readWithMe();
  }

  initiateReadWithMeMode(){
    this.props.speech.speak({textToSpeak: COPY_STRINGS.read_with_me_mode});
    this.readWithMe();
  }

  playRepeatAfterMe(inWord,inIndex){
    this.setState({
      repeateAfterMeInterventionInProcess: true,
      interventionWord: inWord,
      interventionWordIndex: inIndex,
    });
  }

  /** SPEECH RECOGNITION **/
  startListening(source=""){
    if(!this.props.openModal){//do not listen for read phrases if the modal is open
      this.props.speech.startListening(source);
    }
  }

  /** TRANSCRIPTION PROCESSING **/
 getPauseCheck(progress, callback,source){
    return () => {

      const isBadNetwork = this.networkMonitoringService && getUserData().showBadNetworkResponse && this.networkMonitoringService.status === NetworkStatus.Bad;

      if((this.state.endOfPhrase == false) && this.props.speech.isListening && this.props.isReaderActive && isWordInterventionInProcess == false && !isBadNetwork){
        logSessionInfo("pause_check_fired",{holdOffs: interventionHoldoffs});
        callback();
      }
    }
  }


  //count the number of errors we have so far
  // if this number is greater than the story's frustration level, relevel the student
  // for now this only happens in assessment mode
  checkFrustrationLevel(errors){
    if(!this.props.config.assessmentMode || !this.props.orfMode){
      return;
    }

    errors = errors ? errors : this.state.errors;
    let accuracySoFar = calculateAccuracyFromScoredTranscript(errors);
    let studentGrade = getUserData().actualGrade;
    let storyGrade = parseInt(this.props.story.grade);
    logSessionInfo('downlevel_check', {
      src: 'accuracy',
      accuracy: accuracySoFar,
      errors,
      studentGrade,
      storyGrade,
    });

    if(accuracySoFar < 60 && storyGrade <= studentGrade){
      logSessionInfo('downlevel', {
        src: 'accuracy',
        accuracy: accuracySoFar,
        errors,
        studentGrade,
        storyGrade,
      });
      this.reLevel("frustration_error_count");
      return true;
    }
  }

  //This is a stub to use the phon stream for placement
  buildTranscriptFromPhons(phrase){
    let numWords = this.props.numPhonemes/1.5;
    let fakeTranscript = "";
    for(let i=0;(i<numWords && i<phrase.length);i++){
      fakeTranscript += phrase[i];
      if(i<phrase.length-1){
        fakeTranscript += " ";
      }
    }
    console.log(fakeTranscript);
    return {interim: fakeTranscript, final: fakeTranscript};
  }

  shouldUseStruggleMonitor(){
    //Use the struggle monitor if not a spanish story, if the global flag is enabled, and if this is a struggling reader

    // don't use struggle monitor if phoneme placement is enabled
    // currently setPhonemePlacementEnabled manages this flag
    if(getPhonemePlacementEnabled()){
      return false
    }

    return (!(this.props.story.tags && this.props.story.tags.includes("ES-MX")) && //Only if the story has no tags or is not spanish
              getUserData().useStruggleMonitor && isStrugglingReader() &&          //Only with struggling readers
              this.props.story.type === 'tutor');                                 //Only in tutor mode
  }

  evaluateStruggle(phonDelta){
    if(phonDelta && this.shouldUseStruggleMonitor()){
      if(expectedWord){
        const meta = this.props.currentWordMetadata;

        if (meta) {
          if(meta.abPHON){
            struggleType = struggleMonitor.rank(meta.abPHON, phonDelta).attemptKind;
          }else{
            console.log("NO ABPHON",expectedWord)
            struggleType = struggleMonitor.Attempt.SUCCEED;
          }
          wav2vecPhonemes.push({
            time: new Date().getTime() - totalTimeSpentIntervening - recordingStart - timeBetweenPages - this.props.speech.silentSegments().timingOffset,
            expectedWord: expectedWord,
            abPhon: meta && meta.abPHON,
            phonDelta: phonDelta,
            struggleType: struggleType
          })
          console.log("STRUGGLE",struggleType,meta.abPHON,phonDelta)
        } else {
          console.log('NO METADATA FOUND')
          struggleType = struggleMonitor.Attempt.SUCCEED;
        }
      } else {
        struggleType = struggleMonitor.Attempt.SUCCEED;
      }
    }else{
      struggleType = struggleMonitor.Attempt.SUCCEED;
    }
  }

  // checks the current transcription against the phrase to determine whether the user
  // is done reading the phrase and whether the user has read it correctly
  // if transcription for this phrase is finished, updates the UI accordingly
  checkTranscription(){
    let phrase = this.getCurrentPage()[this.state.currentPhraseIndex];
    let newPhraseErrors = [];
    let noAudioTimer = this.state.noAudioTimer;

    if(phrase){
      let cleanPhrase = cleanAndSplit(phrase);
      //### Leave in for now until we're happy with placement
      let currentTranscript = (this.props.story && this.props.story.type === assignmentTypes.DYSLEXIA && this.props.story.tags && this.props.story.tags.includes("ES-MX") && !this.props.speech.getPlacementConfig().useSpanish) ? this.buildTranscriptFromPhons(cleanPhrase) : this.props.transcript;

      //TODO: Reevaluate the signature of this method - way too many paramaters to pass.
      const matchThreshold = this.props.story && this.props.story.type === assignmentTypes.LETTER_NAMING_AND_SOUNDS ? 1 : this.state.matchThreshold;
      let scoredTranscript = scoreTranscript(phrase, currentTranscript, this.state.currentWordIndex, matchThreshold,
      this.props.config.numMatchWords,this.props.config.matchWindow, this.props.config.assessmentMode);
      let cleanTranscript = scoredTranscript.cleanTranscript;

      //TODO: think about moving this parsing into the Phrase component
      // if, based on the length of the transcription, we have not reached the end of the phrase yet
      if(cleanTranscript.length <= cleanPhrase.length){
        /*****************************************************************************
        * accumulators for state update, which will happen at the end of this function
        ******************************************************************************/
        let startReadingTimer = this.state.startReadingTimer;
        let lastProgress = this.state.lastProgress;
        /*****************************************************************************/

        // if we have made progress, update all of our pause check timers and our "last progress"
        if(lastProgress.transcriptLength !== cleanTranscript.length){
          if((cleanTranscript.length - lastProgress.transcriptLength === 1) && (struggleType === struggleMonitor.Attempt.LOW_EFFECT)){
            return;
          }

          struggleMonitor.reset();
          struggleType = this.shouldUseStruggleMonitor() ? struggleMonitor.Attempt.LOW_EFFECT : struggleMonitor.Attempt.SUCCEED;
          expectedWord = cleanPhrase[cleanTranscript.length];
          lastProgress = {
            transcriptLength: cleanTranscript.length,
            time: new Date().getTime(),
          };

          if(this.props.config.enableInterventions && !this.disableInterventionsForPhrase){
            if(startReadingTimer){
              window.clearTimeout(startReadingTimer);
              startReadingTimer = null;
            }
          }

          this.startInterventionTimer(lastProgress);
          interventionHoldoffs = 0;
          this.checkPageNavEnabled();
          if(noAudioTimer){
            window.clearTimeout(this.state.noAudioTimer);
          }
          noAudioTimer = window.setTimeout(this.getPauseCheck(lastProgress, this.onLongPauseDetected, "checktranscript").bind(this), 60000);
        }

        // Implement the "skip-back" algorithm here.
        // Basic algorithm - if we've skipped ahead more than 2 words and read less than 4 words in a row,
        // then allow the user to skip back if the diff returns a match earlier in the string.
        // NOTE: Disabled in assessment mode

        // "Skip Back Logic"
        // We will allow a "skip back" if:
        // 1. A large-ish (> 2) skip was done.
        // 2. The student hasn't read more than 4 consecutive words after the skip
        // 3. The skip-back won't take us back to a word before the last word upon which we intervened.
        // The way we implement the skip-back is by simply not loading the last error state.
        // So, if we say that we want to reset the errors when:
        // (large skip) AND (short match) AND (the transcript is shorter than the error length) AND (skip is after the last word intervention)
        // Then we only want to read the previous error state with the inverse of this logic, so:
        // IF !(large skip) OR !(short match) OR !(the transcript is shorter than the error length) OR !(desired word < last intervention index)
        // One other note: we want to check the previous state of the skip metrics, because when we get
        // a "good" transcript the current state of the skip metrics will not trigger. IOW, what we're
        // really saying is that if we were skipped ahead before the current transcript, we want to trigger
        // the logic.
        let oldPhraseErrors = [];
        if((this.state.prevSkipMetrics.skipLength <= 2)
            || (this.state.prevSkipMetrics.matchLength > 4 ) || (this.getCurrentPhraseErrors().length <= (cleanTranscript.length+2))
            || (scoredTranscript.totalErrors.length < this.state.lastWordInterventionIndex)){
          //store the result of the updated transcription
          oldPhraseErrors = this.getCurrentPhraseErrors();
        }

        let skipMetrics = calculateSkipMetrics(cleanTranscript);

        // combine the running error set with the newly calculated error set to produce our current errors.
        // if a word has been previously marked as correct, keep it correct in our new error set even if our new calculation disagrees
        let currentErrorLength = oldPhraseErrors.length;
        let newErrorHypothesis = scoredTranscript.totalErrors;
        //ensure that the error set is always growing
        let newErrorLength = Math.max(currentErrorLength, newErrorHypothesis.length);
        for(let i = 0; i < newErrorLength; i++){
          let expectedWord = cleanPhrase[i];
          let currentError = oldPhraseErrors[i]; //whether or not this word has been previously marked as an error

          // keep words correct which have previously been marked as correct
          if((currentError || i >= currentErrorLength) && i < newErrorHypothesis.length){
            let error = newErrorHypothesis[i];
            //If this is the last pass, mark all the noise words right
            if((newPhraseErrors.length >= cleanPhrase.length) || (this.state.testTimeExpired)){
              error = this.finalizeError(expectedWord,error);
            }
            newPhraseErrors[i] = error;
          } else {
            newPhraseErrors[i] = currentError;
          }
        }

        // if we've successfully moved the cursor, reset the skip window.
        if(newPhraseErrors.length > currentErrorLength){
          setSkipWindow('default');
        }

        // update the current word index and the score based on our new score data
        // note that this will also update the currentWordIndex, keeping the cursor consistant with our error length
        scoredTranscript.totalErrors = newPhraseErrors;
        this.setCurrentPhraseScore(scoredTranscript);

        //Calculate placement timings
        let timingObject = {
          position: newPhraseErrors.length + overallPosition,
          word: cleanPhrase[newPhraseErrors.length], //This is right (no -1) because we want to know where the cursor is.
          time: new Date().getTime() - totalTimeSpentIntervening - recordingStart - timeBetweenPages - this.props.speech.silentSegments().timingOffset,
          transcript: this.props.transcript.interim,
          struggle: struggleType,
          errors: scoredTranscript.totalErrors,
          placementText: scoredTranscript.cleanTranscript,
          overallPhraseIndex
        }

        if((timings.length > 0) && (timings[timings.length-1].position !== newPhraseErrors.length)){
          timings.push(timingObject);
        }
        console.log(this.props.transcript.interim);
        /*********************************************************************
        * Update the state now that we have finished processing the transcript
        **********************************************************************/
        this.setState({
          noAudioTimer: noAudioTimer,
          startReadingTimer: startReadingTimer,
          lastProgress: lastProgress,
          prevSkipMetrics: skipMetrics,
        });
        /*********************************************************************/
      }

      // if we've hit the end of the phrase
      if((newPhraseErrors.length >= cleanPhrase.length) || this.state.waitingForFinalTranscript || (this.state.testTimeExpired)){
        //Deal with timing-related stuff regardless of whether we have a final transcript or not
        if(!this.state.endOfPhrase){
          this.handlePotentialEndOfPhrase();
        }

        this.clearInterventionTimer();

        // clear the "no audio timer"
        // this timer is used to call `onLongPauseDetected` if we have no progress after 30 seconds.
        // This progress monitoring is reset here because we don't want to be counting between phrases
        if(noAudioTimer){
          window.clearTimeout(noAudioTimer);
        }

        // If we are not in assessment mode, fire the end of phrase logic without waiting for the final transcript.
        // This has the net result of possibly cutting off part of the last word => we compensate for this in tutor
        // by using the front end 'answer' for the last word, but the assessment needs the whole recording.
        if(((!this.state.endOfPhrase) && (!(this.props.orfMode && getUserData().assessmentPageNavEnabled && this.props.config.assessmentMode)) ||this.state.testTimeExpired)){
          //Set the state variable to make sure this code only executes once
          this.setState({endOfPhrase: true});

          //###Put on a 500 ms delay to avoid cutting off the last word
          window.setTimeout(()=>{
            //call the function which ends this phrase, cleans up, and moves on to the next one
            let isRecording = this.props.speech.isRecording();
            this.onPhraseEnd(isRecording);
          },500)
        }
      }
    }
  }

  //This cleans up a single error - intended to be called as we iterate through our errors once we've hit the end of a phrase.
  finalizeError(expectedWord,inError){
    let error = inError;
    if((this.props.config.ignoreNoiseWords == true) && (isStopWord(expectedWord))){
      error = false;
    }
    return error;
  }

  //Handle various things when we believe we've reached the end of the current transcript
  handlePotentialEndOfPhrase(){
    this.clearInterventionTimer();
    totalTimeSpentIntervening += phraseTimeSpentIntervening;
    phraseTimeSpentIntervening = 0;

    this.setState({
      endOfPhrase: !this.props.config.assessmentMode && !isEarlyReaderMode(this.state.earlyReaderMode),
      waitingForFinalTranscript: true, //This ensures that once we hit the end of phrase, we aren't reliant on the errors array to move on.
    });
  }

  findWordToIntervene(){
    let interventionIndex = this.state.currentWordIndex;
    return(this.getCurrentWord(interventionIndex, true)); //Don't do anything fancy, but keep the code below in case we want to turn it back on
  }

  /** READER UI **/

  //close the modal and start listening once it has been closed
  closeModal(advanceOneWord = false){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.CLOSE_MODAL });
    let onModalClose = null;
    if(!this.state.endOfPhrase){
      onModalClose = () => {
          if(this.props.speech && this.props.story && !this.props.story.nonAudio && this.state.storyInProgress){
            this.props.speech.startListening("closeModal");
          }
          advanceOneWord && this.advanceOneWord();
      }
    }

    if(this.state.intervenedOnLastWord){
      this.setState({intervenedOnLastWord: false});
    }

    logSessionInfo("modalClosed_"+this.state.lastIntervention,{word: this.getCurrentWord().trim(), type: this.state.lastIntervention, index: this.state.currentWordIndex});
    this.props.closeModal(onModalClose);
  }

  abortIntervention(){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.INTERVENTION_ABORT });
    // Call props.closeModal directly first to avoid race condition where abortListen and abortSpeech are resolved before the modal is unmounted
    // If modal is not unmounted before those calls, then cancellablePromise in intervention-library cannot work properly
    this.props.closeModal(); // It is safe for props.closeModal to be called multiple times, which will happen when we call this.closeModal()

    abortListen(this.props.speech, this.state.endOfPhrase);
    this.props.speech.abortSpeech(() => {
      if (this.state.endOfPhrase) {
        this.closeModal();
        this.cleanUpAfterIntervention();
      }else{
        this.onInterventionEnd();
      }
      logSessionInfo("interventionClosed", { location: this.props.location, history: this.props.history, state: this.state});

      // Safegaurd to account for intervention audio right after clicking aborting sometimes gets through, but is so far disjuncted from this method
      window.setTimeout(() => this.props.speech.startListening("abortIntervention"), 2500);
    }, {returnToListening: true});
  }

  returnHome(){
    this.props.history.push('/student/home');
  }

  readAloudIntent(){
    if(this.props.config.squashedStory){
      this.readAloudWithCallback(this.returnHome);
    }else{
      this.readAloudWithCallback(() => {
        if(this.state.currentPhraseIndex == (this.props.story.pages[this.props.pageIndex].length - 1)){//If Last Phrase
          if(this.props.pageIndex >= (this.props.story.pages.length - 1)){//If Last Page
            this.returnHome();
          }else{
            this.props.goToNextPage();
          }
        }else {
          this.nextPhrase(this.readAloudIntent);
        }
      });
    }
  }

  //Display this while Amira is saying her opening statement during the assessment
  async openIntroModal(callback,type){
    await this.props.speech.playAppSoundsWithPromise({
      url: silence,
      key: "silence",
    })
    this.openModal(
      <div className="introModal labelFontOverride">
        {COPY_STRINGS.please_wait(GetBrandedTutorName())}
      </div>,
      { logName: "introModal", }
    );

    let textToSpeak = [];

    // select the intro text based on context
    // If this is the first activity in the browser session, greet the student
    if(this.props.firstAssignment){
      textToSpeak.push("<speak>" + COPY_STRINGS.hello + " " + getUserData().firstName + "</speak>");
      textToSpeak.push(this.props.forcedAssessment ? COPY_STRINGS.assigned_amira_intro(GetBrandedTutorName()) + " <break time=\"1.8s\"/> " : this.selfAssignedIntro);
    }

    // Select the instructions based on activity type
    let assignment = this.getCurrentAssignment();
    let instructionText = (getActivityIntroText(assignment.type, getUserData()))();

    if(this.props.story && this.props.story.alternateIntroText){
      textToSpeak.push(this.props.story.alternateIntroText);
    }else {
      textToSpeak.push(instructionText);
    }

    //If we just did an activity in this browser session, give some props before continuing
    if(!this.props.firstAssignment){
      textToSpeak = [COPY_STRINGS.next_section_transition];
      textToSpeak.push(instructionText);
    }

    //If we just downleveled, forget all of the above and say the blurb for that.
    if(this.props.midAssessment){
      textToSpeak = [this.repeatIntro];
    }

    //If we're starting a reading comp activity, just speak the reading comp instructions
    //to avoid the redundancy in next_section_transition and repeatIntro
    if(assignment.type === assignmentTypes.READING_COMPREHENSION){
      textToSpeak = [instructionText];
    }

    if(this.props.skipIntros){
      textToSpeak = [this.devIntro];
    }

    let speechArray = textToSpeak.map((tts)=>{
      return({textToSpeak: tts})
    });

    let speechProps = {
      textToSpeak: speechArray,
      passThroughSpeechTags: true,
      onEnd: () => this.openGoModal(callback),
    };

    this.props.speech.speakSequence(speechProps);
  }

  openGoModal(callback){
    if(
      ( // If we are early reader and we are not in an assessment ORF section
        getUserData().isEarlyReader &&
        !(this.props.orfMode && this.props.config.assessmentMode)
      ) ||
      // If we are in an assessment and not in the ORF section
      (!this.props.orfMode && this.props.config.assessmentMode)
    ){
      //if this is an early reader or a dyslexia activity, skip the go modal
      // TODO: do this in a cleaner nicer way
      callback();
      return;
    }
    this.openModal(
      <GoModal
        callback={callback}
        speech={this.props.speech}
      />,
      { logName: "goModal", }
    );
  }


  onStoryStart(){
    this.props.logTimeOnStoryStart();//Log the time when the story starts
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_START, 'breadcrumb': "logged time on story start" });

    this.closeModal();
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_START, 'breadcrumb': "closed modal" });

    this.props.initializeStoryWordMetadata(this.props.story, overallPhraseIndex, this.state.currentWordIndex);
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_START, 'breadcrumb': "initialized story word metadata" });

    setStudentLevelByGrade(this.props.story.grade);
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_START, 'breadcrumb': "set student level by grade", 'grade': this.props.story.grade });

    studentRecordService.updateStatus(this.state.activityId,statusType.STARTED);
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_START, 'breadcrumb': "updated status to started" });

    // check the phrase type to see if we need to enable phoneme placement
    this.props.speech.setPhonemePlacementEnabled( shouldEnablePhonemePlacement(this.props.story, overallPhraseIndex) );

    this.setState({storyStarted: true});
    if(this.props.story && this.props.story.type !== assignmentTypes.ASSESSMENT){
      if(this.isEarlyReader()){
        updateErssStatus(getUserData().userId,this.state.activityId,this.props.story.tags,"STARTED")
      }

      //temporary fix for non-assessment activities being down-leveled. need to investigate why orfMode = true during tutor
      this.setState({
        frustrationLevelChecked: true,
        storyInterventions: this.getBoolArrayFromStory(this.props.story)
      });
    }else if(this.props.orfMode && this.props.config.enableAssessmentTimer){ //TODO: make a separate dyslexia config instead of checking mode here
      //Set up the assessment timer here if applicable
      let assessmentTime = this.props.config.developerMode ? 20000 : this.props.config.assessmentTime;
      assessmentTimer.set(assessmentTime)
      .then(()=>{
        this.setState({testTimeExpired:true});
      });

      //Set up the downleveling checks
      this.startRelevelTimer();
      this.setState({frustrationLevelChecked: false});
    }
  }

  getBoolArrayFromStory(story){
    if(story){
      return story.phrases.map((phrase)=>{
        return cleanAndSplit(phrase).map(()=>false);
      })
    }else{
      return [[]]
    }
  }

  onError(forceError = false){
    //for now only do this in assessment mode. It is less critical if an activity is not recorded in tutor mode
    if(this.props.config.assessmentMode || forceError){
      this.props.speech.abortSpeech();
      this.openModalAndStopListening(
        <ErrorModal
          type={getErrorModalTypes().ERROR}
          speech={this.props.speech}
        />
      );
      this.setState({
        error: true,
      });
    }
  }

  // We have different workflows depending on whether a student self-selected or whether a teacher assigned an activity.
  // This method is used when a student selects a story or picks "take a test" from the UI.
  async launchSelfAssignedActivity(id,callback,activityType){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_LAUNCH_SELF_ASSIGNED });
    try {
      // When we choose a story, create an activity object on the server to start tracking the student's audio and errors
      if(activityType === assignmentTypes.ASSESSMENT){
        console.log("Forcing assignment");
        this.props.forceAssignment();
        return;
      }

      let { userId, schoolId, districtId, locale } = getUserData();
      let activityTags = [];
      if(locale === 'es-mx'){ //TODO: this is gross. need to pick a locale format and use constants
        activityTags.push('ES_MX');
      }

      console.log("Self assigned",id,callback,activityType);
      const response = await studentRecordService.createActivity(activityType, userId, id + "", activityStatus.SCORING_NOT_STARTED,this.onPutActivityFailure,statusType.LAUNCHED,districtId,schoolId,activityTags);

      const { activityId } = response.data.putActivity;
      //Leave this log statement in - it's our only way of knowing what activityId was assigned
      // and tracing it through the system while debugging.
      console.log("Created new activity. activityId: ", activityId, activityType);
      setSessionActivityId(activityId, this.props.config.assessmentMode);
      this.props.speech.initializeSpeechSession(activityId,activityType === assignmentTypes.TUTOR ? getUserData().locale : 'en-us',isStrugglingReader(),false);
      logSystemData();
      this.setState({activityId});
      if(this.props.config.assessmentMode){
        this.openIntroModal(callback,activityType);
      } else {
        if(this.props.asrStoryID){
          callback() // starts the story
        }else{
          this.openGoModal(callback);
        }
      }

      if(!this.props.config.assessmentMode){
        startEDMSession(this.onErrorsAreValid,this.updateFrameTime, this.onDetectionEnd);
      }
    } catch (error) {
      console.error("launchSelfAssignedActivity", error);
      logSentryException(error, "Error on launchSelfAssignedActivity");
      throw error;
    }
  }


  getCurrentAssignment(){
    return this.props.forcedAssessment;
  }

  markForcedAssessmentComplete(){
    if(this.props.forcedAssessment && this.props.forcedAssessment.activity && this.props.forcedAssessment.activity.length) {
      this.props.forcedAssessment.activity.forEach(async (activity) => {
        if(activity.status !== activityStatus.SCORING_NOT_STARTED) {
          let displayStatus = (this.isOldAssignment(this.props.forcedAssessment)) ? this.props.forcedAssessment.displayStatus : statusType.UNASSIGNED;
          await studentRecordService.markCompleted(activity.activityId, displayStatus);
        }
      });
    }
    return Promise.resolve(null);
  }

  isOldAssignment(activity){
    if(!activity) return false;

    switch(activity.displayStatus){
      case statusType.UNASSIGNED:
      case statusType.MUTED:
      case statusType.STUCK_PLACEMENT:
        return true;
      default:
        return false;
    }
  }

  async reparentAllPreviousActivities(newParentId){
    let activityStack = getActivityStack();

    const { results, errors } = await PromisePool
    .withConcurrency(3)
    .for(activityStack)
    .process(async act => {
      const success = await this.reparentActivity(act,newParentId);
      return success;
    })
    return Promise.resolve(errors && errors.length ? false : true);
  }

  reparentActivity(activityId,newParentId,retries = 3){
    return studentRecordService.setParent(activityId,newParentId)
    .then(resp=>{
      //Retry on any errors (note: The srs method won't throw, we get back errors in the payload)
      if(resp.errors || !resp.data || !resp.data.updateActivity.activityId){
        if(retries){
          console.log("RETRYING PARENT");
          return(this.reparentActivity(activityId,newParentId,retries-1))
        }else{
          logSessionInfo("reparent_failed",{activityId, newParentId,resp});
          const parentError = new Error("reparent_failed");
          logSentryException(parentError, "Error reparent_failed");
          return Promise.reject(parentError);
        }
      }else{
        return Promise.resolve(true);
      }
    })
  }

  addNewChildToChain(newChildId){
    if(this.props.parentActivityId){
      return studentRecordService.setParent(newChildId, this.props.parentActivityId);
    } else {
      return Promise.resolve(null);
    }
  }

  doParenting(type, activityId){
    if(type === assignmentTypes.READING_COMPREHENSION){
      const activityStack = getActivityStack();
      let parentId;
      if(activityStack.length > 0){
        parentId = getActivityStack()[getActivityStack().length-1];
      } else {
        const currentAssignment = this.getCurrentAssignment();
        parentId = currentAssignment ? currentAssignment.parentId : null;
      }
      return parentId ? this.reparentActivity(activityId, parentId) : Promise.resolve();
    } else {
      return this.reparentAllPreviousActivities(activityId);
    }
  }

  // This method is used when a student is forced to take an activity because it was assigned to them.
  async launchAssignedActivity(id,callback){

    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_LAUNCH_ASSIGNED, storyId: id});
    try {
      let userData = getUserData();

      //First, mark the old assignment completed. This is to avoid concatenating data (such as audio) with a previous attempt.
      await this.markForcedAssessmentComplete();

      const currentAssignment = this.getCurrentAssignment();
      const type = currentAssignment && currentAssignment.type ? currentAssignment.type : assignmentTypes.ASSESSMENT;
      const locale = (currentAssignment && currentAssignment.locale) ? formatLocale_UpperCaseUnderscore(currentAssignment.locale) : 'EN_US';
      let activityTags = locale === 'ES_MX' ? [locale] : [];
      const {assignmentConfiguration} = getUserData();
      if(assignmentConfiguration){
        activityTags.push(assignmentConfiguration)
      }
      let isCalibration = currentAssignment && currentAssignment.isCalibration;
      if(currentAssignment && currentAssignment.tags) activityTags = currentAssignment.tags;
      const assignmentId = this.props.studentAssignment ? this.props.studentAssignment.assignmentId : null;
      console.log("ASSIGNMENT:", currentAssignment);

      //Next, create a new activity with a status of "assigned". This will ensure the student's status remains assigned until they finish
      // if they happen to close the browser and not give us the ability to change it.
      const response = await studentRecordService.createActivity(type, userData.userId, id + "", activityStatus.ASSIGNED,this.onPutActivityFailure,statusType.LAUNCHED,getUserData().districtId,getUserData().schoolId,activityTags,assignmentId);

      //Leave this log statement in - it's our only way of knowing what activityId was assigned
      // and tracing it through the system while debugging.
      const { activityId } = response.data.putActivity;
      console.log("Started assigned activity. activityId: ", activityId, type);

      //set the abandoned "assignment" activity as the parent of the new activity, so that we can keep track of the history of attempts/assignments
      await this.addNewChildToChain(activityId);

      // Reparent any children of the old activity to the one we created above
      await this.doParenting(type, activityId);

      setSessionActivityId(activityId, this.props.config.assessmentMode);

      this.props.speech.initializeSpeechSession(activityId,(type === assignmentTypes.TUTOR || type === assignmentTypes.ASSESSMENT) ? getUserData().locale : 'en-us' ,isCalibration,type === assignmentTypes.ASSESSMENT);
      logSystemData();
      this.setState({activityId: activityId});
      if(this.props.bifurcatedAssignment){
        this.displayStudentStatus();
        return;
      }else{
        if(this.props.config.assessmentMode){
          setUseGenerativeVoiceGlobal(true); // Enable generative voice for all speech in assessment
          this.openIntroModal(callback,type);
        } else {
          this.openGoModal(callback);
        }
      }
      if(!this.props.config.assessmentMode){
        startEDMSession(this.onErrorsAreValid,this.updateFrameTime, this.onDetectionEnd);
      }
      //If there is an existing activity ID, then set the set the parent/child relationship.
      //Examples of this are when we're transitioning from Dyslexia to ORF, or when we're downleveling.
      //This will allow the last activity taken in this session to carry all previous attempts as children, so we can
      //walk through the history.
      //NOTE: the way this works is to just set the parentId. The childId on the ORF will automatically get updated by the back end
      let stack = getActivityStack();
      if(stack.length){
        // TODO: Evaluate whether this should be in the promise chain or if it's ok to leave this async task hanging
        // TODO: Proper error handling.
      }
      //Finally, push this activity onto our local stack for the next go-round.
      addToActivityStack(activityId);
    } catch (error) {
      console.error("launchAssignedActivity", error);
      logSentryException(error, "Error on launchAssignedActivity");
      this.onError(
        true, // force the error to show
      );
    }
  }

  onStoryFetchFailure() {
    this.openModal(
      <ErrorModal
        type={getErrorModalTypes().FATAL_STORY_FETCH_FAILURE}
        speech={this.props.speech}
        continue={() => this.props.history.push('/student')}
      />,
      { logName: "storyFetchFailure", }
    );
  }

  onRecFetchFailure() {
    this.openModal(
      <ErrorModal
        type={getErrorModalTypes().FATAL_REC_FETCH_FAILURE}
        speech={this.props.speech}
        continue={() => this.props.history.push('/student')}
      />,
      { logName: "recFetchFailure", }
    );
  }

  onPutActivityFailure() {
    this.openModal(
      <ErrorModal
        type={getErrorModalTypes().FATAL_PUT_ACTIVITY_FAILURE}
        speech={this.props.speech}
        continue={() => this.props.history.push('/student')}
      />,
      { logName: "putActivityFailure", }
    );
  }

  // when a story is selected in the story picker, open the go modal and wait until it's done doing its thing to actually set the story
  selectStory(id){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_PICKED, storyId: id});
    // Reset intervention history before beginning a story
    resetInterventionHistory();
    let callback = () => {
      this.setStory(id);
    };

    return getStory(id)
    .then((story)=>{
      let activityType = story.type;
      this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_FETCHED, storyId: id, storyType: activityType});

      if(!story){
        activityType = this.props.config.assessmentMode ? 'assessment' : 'tutor';
      }
      if(this.props.forcedAssessment){
        this.launchAssignedActivity(id, callback);
      }else{
        this.launchSelfAssignedActivity(id,callback,activityType);
      }
    }).catch(err => {
      console.log("Error getting story.", err)
      logSentryException(err, "Error getting story.");
      this.onStoryFetchFailure();
    });
  }

  setStory(id){
    const callback = this.props.config.isReadAloud ? this.readAloudIntent : null;
    this.props.setStory(id, this.props.config, () => {
      if (callback) {
        callback();
      }
    });
  }

  openStoryPicker(){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_PICKER_OPENED });
    if(this.props.speech){
      if(this.state.recommendedStories && this.state.recommendedStories.length > 0){
        const title = COPY_STRINGS.which_story(this.props.config.isReadAloud);
        this.openModal(
          <StoryPicker
            title={title}
            setStory={this.selectStory}
            close={this.closeModal}
            recommendedStories={this.state.recommendedStories}
            speakChooseStoryMessage={speakChooseStoryMessage}
            sendMessage={this.props.sendMessage}
            speech={this.props.speech}
            resetTranscript={this.props.speech.resetTranscript}
          />,
          {backgroundClose: false, key:"storyPicker", logName: "storyPicker"}
        );
      } else {
        this.openModal(
          <div className="emptyMessage">{COPY_STRINGS.no_stories_text}</div>,
          {backgroundClose: false, key:"storyPicker", logName: "storyPicker"}
        );
        speakChooseStoryMessage(this.props.speech, this.state.recommendedStories, (() => this.props.history.push('/student/home')));
      }
    } else {
      window.setTimeout(this.openStoryPicker, 5);
    }
  }

  async openGradePicker(){
      if(this.props && this.props.speech){
        if(this.props.speech.isMicMuted) {
          this.openModal(
            <ErrorModal
              type={getErrorModalTypes().MUTE}
              speech={this.props.speech}
              continue={this.openGradePicker}
            />,
            { logName: "muteError" }
          );
        } else {
          // Always use the actual grade of the student in assessment
          let grade = getUserData().actualGrade;
          if(!this.props.config.assessmentMode || this.props.midAssessment){
            let studentGradeLevel = getStudentGradeLevel(true);
            grade = (this.props.midAssessment || ((studentGradeLevel || studentGradeLevel == 0) && (!getUserData().demoMode && (process.env.IGNORE_STUDENT_HISTORY !== 'TRUE')))) ? studentGradeLevel : getUserData().grade;
          }

          // If we are launching directly into a readingComprehension portion of an assessment, fetch the last ORF to determine the grade
          // Handles case where user was releveled on an ORF, restarted, and is now on the readingComprehension portion. We want comprehension grade to match the ORF grade
          if (
            this.props.config.assessmentMode &&
            this.props.assignmentIndex === 0 &&
            this.props.allAssignments &&
            this.props.allAssignments[0].activityType === assignmentTypes.READING_COMPREHENSION
          ) {
            const allStatuses = ["scored","rescored","assigned","not_started","in_progress","scoring","underReview","inProgress","reassess"]; // Provide all possible statuses to ensure we grab the latest ORF
            const orfActivities = await studentRecordService.studentActivities(getUserData().userId, 1, ["assessment"], allStatuses);
            if (orfActivities && orfActivities.length > 0) {
              const orfGrade = parseInt(orfActivities[0].story.grade);
              setStudentGradeLevel(orfGrade);
              grade = orfGrade;
            }
          }

          //If we have a valid grade, bypass the grade picker, unless we explicitly want to pick stories or are on staging
          if((grade !== null) && (process.env.ENABLE_GRADEPICKER !== 'TRUE') && !this.props.selectStories){
            this.selectGrade(grade);
          }else{
            this.openModal(
              <GradePicker
                close={this.props.closeModal}
                sendMessage={this.props.sendMessage}
                studentName={this.props.studentName}
                history={this.props.history}
                speech={this.props.speech}
                resetTranscript={this.props.speech && this.props.speech.resetTranscript}
                selectGrade={this.selectGrade}
              />,
              {backgroundClose: false, key:"gradePicker", logName: "gradePicker"}
            );
          }
        }
      } else {
        window.setTimeout(this.openGradePicker, 5);
      }
  }

  selectGrade(grade){
    setStudentLevelByGrade(grade);
    setStudentGradeLevel(grade);
    let activityType = assignmentTypes.TUTOR;
    if(this.props.config.assessmentMode){
      let currentAssignment = this.getCurrentAssignment();
      activityType = currentAssignment && currentAssignment.type ? currentAssignment.type : assignmentTypes.ASSESSMENT;
      if(currentAssignment && !this.props.bifurcatedAssignment) {
        currentAssignment && this.props.setLocale(currentAssignment.locale);
      }
    }
    this.openModal(
        <div className="loadingModal">
          <div className="loadingText __subtitle">{COPY_STRINGS.loading}...</div>
          <div className="loadingWrapper"><Loading noFill={true}/></div>
        </div>,
        { logName: "loadingModal" }
    );
    if(this.props.forceStory){
      this.selectStory(this.props.forceStory);
    } else {
      const assignmentType = this.props.studentAssignment ? this.props.studentAssignment.assignmentType : null;
      getStoriesByGrade(grade,activityType,assignmentType,this.props.selectStories).then((stories) => {
        if(!(stories && stories.length !== 0)){
          logSessionInfo("bin_exhaustion",this.props.forcedAssessment);
          this.onNoStories();
          return;
        }
        // if we only have 1 story, skip the story picker and get straight into reading. Otherwise, open the story picker
        if(stories.length == 1){
          this.selectStory(stories[0].storyId);
        } else {
          this.closeModal()
          this.setState({
            recommendedStories: stories,
          }, this.openStoryPicker);
        }
      })
      .catch(err=>{
        console.log("ERROR IN SELECT GRADE",err);
        logSentryException(err, "Error getting stories by grade");
        this.onRecFetchFailure();
      });
    }
  }

  setPhraseGrammar(index){
    let phrases = this.getCurrentPage();

    if(this.props.speech && phrases[index]){
      this.props.speech.setGrammar(phrases[index]);
    }
  }

  // advance the phrase index, moving focus to the next phrase of the page
  nextPhrase(callback=null, enableRecording = true){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.PHRASE_INCREMENT });
    // reset the aiService's record of word-level interventions
    trackWordInterventionPhraseBoundary();

    if(!this.state.minTimeElapsed){
      return;
    }
    handledErrors = false;
    setSkipWindow('default');
    this.setDisableInterventionsForPhrase(false);
    this.setPhraseGrammar(this.state.currentPhraseIndex + 1);
    overallPhraseIndex++;

    // check the phrase type to see if we need to enable phoneme placement
    this.props.speech.setPhonemePlacementEnabled( shouldEnablePhonemePlacement(this.props.story, overallPhraseIndex) );

    this.setState({
      currentPhraseIndex: this.state.currentPhraseIndex + 1,
      phraseEnded: false,
      currentWordIndex: 0,
      pauseLength: this.getStudentPauseTime(), // NOTE: reset pause time to default value, prior to fetching word metadata
      endOfPhrase: false,
      waitingForFinalTranscript: false,
      lastProgress: defaultLastProgress,
      prevSkipMetrics: {skipLength: 0, matchLength: 0},
      isFinal: false,
      lastWordInterventionIndex: -1,
      retry: false,
      phraseComplete: false,
      minTimeElapsed: false,
      savedPhraseErrors: null,
    }, callback);
  }

  getCurrentWord(index=this.state.currentWordIndex, forDisplay = false){
    let word = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex], forDisplay)[index];
    return word || '';
  }

  buildPhraseId(phraseIndex){
    let phraseId = "";
    let title = this.props.story.title.replace("\'","");
    title = unidecode(title);
    title = cleanAndSplit(title);
    phraseId = title.join('_');
    let graphSuffix = "_" + (phraseIndex+1);

    if(this.props.speech.altPlacement && this.props.config.assessmentMode && this.props.orfMode){
        graphSuffix += "_page";
    }

    phraseId += graphSuffix;
    return {phraseId,graphSuffix};
  }

  // Return the equivalent intervention types for the current (if any) ERSS skill that user is on.
  //    Used to disable said intervention when determining interventions
  getCurrentERSSInterventionTypes() {
    const tags = this.props.story.tags;

    if(!tags) return [];

    if (tags.includes("EARLY_READER_CHANGE_ONE_PART")) {
      return [interventionType.changeOnePart1];
    }

    if (tags.includes("EARLY_READER_UP_AND_DOWN")) {
      return [
        interventionType.upAndDown1,
        interventionType.upAndDown2,
        interventionType.upAndDown3
      ];
    }

    if (tags.includes("EARLY_READER_LETTER_FLIES")) {
      return [interventionType.letterFlies];
    }

    if (tags.includes("EARLY_READER_ELKONIN_BOXES")) {
      return [
        interventionType.elkoninBox0,
        interventionType.elkoninBox1,
        interventionType.elkoninBox2,
        interventionType.elkoninBox3,
        interventionType.elkoninBox4
      ];
    }

    return [];
  }

  // reset the phrase transcript and error tracking for the current phrase,
  // and prompt the reader to try reading the phrase again
  tryAgain(customGambit=getTryAgain(),disableRecording=true,speakPrompt=true){
    let callback = function () {
      this.setCurrentPhraseErrors({});
      let myRecordingProps = JSON.parse(JSON.stringify(this.state.recordingProps));
      myRecordingProps.disableBackend = disableRecording;
      myRecordingProps.done = false;
      this.props.speech.enableRecording(myRecordingProps); // logs socket_connected event
      this.props.speech.startListening("tryAgain");
      this.setState({
        lastProgress: defaultLastProgress,
        currentWordIndex: 0,
        pauseLength: getPauseTime(0),
        callbackAfterIntervention: null,
        interveningAtEndOfPage: false,
        isFinal: false,
        endOfPhrase: false,
        waitingForFinalTranscript: false,
        retry: disableRecording ? true:false,
      });
    }.bind(this);

    if(speakPrompt){
      let props = {};
      props.text = customGambit;
      props.callback = callback;
      this.props.sendMessage(props);
    }else{
      callback();
    }
  }

  getCurrentPage(){
    if(this.props.story){
      return this.props.story.pages[this.props.pageIndex];
    } else {
      return [];
    }
  }

  getCurrentPhraseMetaData(){
    let currentMeta = {};
    if(this.props.story && this.props.story.items && this.props.story.items[overallPhraseIndex]){
      currentMeta = this.props.story.items[overallPhraseIndex];
    }
    return currentMeta;
  }

  clearTimingSessionVariables(){
    timings = [{time: 0, position: 0}];
    overallPosition = 0;
    timeBetweenPages = 0;
    lastRecordingStop = 0;
    phraseStartTime = 0;
    totalTimeSpentIntervening = 0;
    stopTime = 0;
    handledErrors = false;
    predictionConfidences = [];
    phraseDelays = [];
    interventionTime = 0;
    interventionHoldoffs = 0;
  }

  clearTimingVariables(){
    this.clearTimingSessionVariables();
    phraseTimeSpentIntervening = 0;
  }

  cleanUpAfterAssessment(aborted){
    this.clearTimingVariables();
    //We are done if and only if:
    //1. It's the last assignment in a sequence OR
    //2. If we've aborted, the test is not a Spanish test, and either the student is not an ESL or if the student is an ESL and the English story isn't first.
    //If neither are true, then we move on to the next assignment.
    if(this.props.lastAssignment ||
      (aborted && !isSpanishStory(this.props.story) &&
      (!getUserData().isESL ||
      (getUserData().isESL && (getUserData().spanishConfig !== 'BOTH_TWO_SESSIONS_ENGLISH_FIRST') && (getUserData().spanishConfig !== 'BOTH_ONE_SESSION_ENGLISH_FIRST'))
    ))){
      this.setState({testTimeExpired:false}); //TODO: Consolidate end of assessment stuff into one method.
      this.displayStudentStatus(this.state.testTimeExpired || aborted);
    }else{
      // If next assignment is not readingComprehension, then we should reset the readerCharacteristics studentGrade back to actualGrade
      // We only want to carry over ORF releveling to readingComprehension. Not to any other assignments (like if we are going to a fresh spanish assessment)
      if (this.props.allAssignments && this.props.allAssignments[this.props.assignmentIndex + 1].activityType !== assignmentTypes.READING_COMPREHENSION) {
        setStudentGradeLevel(getUserData().actualGrade);
      }

      //TODO (post-MVP): Check licensing
      this.launchNextAssignment();
    }
  }

  finalizeAssessment(aborted){
    // Need to create a copy of the object because we use it asynchronously and the
    // timings will be cleared below before the calculatePhraseSplits call returns
    endUniversalSocketSession();
    const rawTimings = JSON.parse(JSON.stringify(timings));
    let shouldPadSlices = true; //TODO: restore this line when we're glitch-free this.props.orfMode; //Don't add padding to the slicing for dyslexia since it's 1 phrase, 1 page.
    if(this.props.story.nonAudio){
      studentRecordService.saveTextResponses(this.state.activityId, this.state.simpleErrors, this.state.textResponse)
      .then(() => {
        this.cleanUpAfterAssessment(aborted);
      });
    } else {
      calculatePhraseSplits(timings,this.props.story.storyId,stopTime-this.props.speech.silentSegments().timingOffset,shouldPadSlices)
      .then(splits => {
        saveAssessmentTiming(this.state.activityId,splits,rawTimings);
        this.cleanUpAfterAssessment(aborted);
      })
      .catch((err)=>{
        logSessionInfo("errorCalculatingSlicing",{
          timings: timings,
          storyId: this.props.story.storyId,
          stopTime: stopTime,
          timingOffset: this.props.speech.silentSegments().timingOffset,
          shouldPadSlices: shouldPadSlices,
          error: err
        });
        this.cleanUpAfterAssessment(aborted);
      })
    }
  }

  finalizeTutor(){
    endUniversalSocketSession();
    const onDoneWaiting = getUserData().isEarlyReader ? this.displayEarlyReaderStatus : this.displayStudentStatus;
    onDoneWaiting();
  }

  openWaitModal(callback,aborted){
    this.openModalAndStopListening(
      <WaitModal
        doneWaiting={isSendingComplete}
        progress = {sendingProgress}
        continue={callback.bind(this,aborted)}
        timeOut = {90000}
      />
    );
  }

  handleEndOfAssessment(abortStatus=null){
    if(abortStatus){
      //TODO import function and uncomment when we merge
      logSessionInfo("activity_aborted",{activityId: this.state.activityId, abortStatus: abortStatus});
    }
    this.setState({testTimeExpired: false});  //Acknowledge the flag so we don't get into a loop because of all the ovverides on time expired.
    if(this.props.speech){
      stopTime = new Date().getTime() - this.state.timeSpentIntervening - recordingStart;
      this.props.speech.disableRecording(true);
      this.props.speech.stopListening();

      let completionPromises = [];
      //If we aborted, preserve the assignment if we have a multi-part
      if(abortStatus){
        if(this.props.bifurcatedAssignment){
          completionPromises.push(studentRecordService.markAbortedKeepingAssignment(this.state.activityId,abortStatus));
        }else{
          completionPromises.push(studentRecordService.markAborted(this.state.activityId,abortStatus));
        }
        let locale = isSpanishStory(this.props.story) ? "ES_MX" : "EN_US"
        completionPromises.push(skipActivityInManifest(this.props.studentAssignment.assignmentId,"readingComprehension",locale))
      }else{
        completionPromises.push(studentRecordService.markCompleted(this.state.activityId,statusType.COMPLETED));
      }

      Promise.all(completionPromises)
      .then(async ()=>{
        if(this.props.story.nonAudio){
          this.finalizeAssessment();
        }else{
          this.sendEndOfStoryRecording();
          //remove early readers after successful completion an orf assessment
          //TODO: spanish story condition will have to change when we support a spanish early reader sequence
          if(!abortStatus && this.props.orfMode && (getUserData().isEarlyReader || getUserData().isSpanishEarlyReader)){
            await clearEarlyReader(getUserData().userId,getUserData().locale);
            logSessionInfo("early_reader_cleared_post_orf", {activityId: this.state.activityId});
          }
          this.openWaitModal(this.finalizeAssessment,abortStatus ? true : false);
        }
      })
      .catch(err=>{
        console.log(err);
        logSentryException(err, "Error completing activity");
      });
    }else{
      this.clearTimingVariables();
      this.displayStudentStatus(this.state.testTimeExpired || abortStatus ? true : false);
      this.setState({testTimeExpired:false})
      if(this.props.forcedAssessment){
        this.props.clearAssignment();
      }
    }
  }

  //TODO de-dup
  // note, this is for assessments aborted due to relevel or "sign out and restart" button.
  //   the "end assessment" button and bottoming out of K level both save assessments via "handleEndOfAssessment"
  handleAbortedAssessment(src=null){
    if(this.props.speech){
      let stopTime = new Date().getTime() - this.state.timeSpentIntervening - recordingStart;
      this.props.speech.disableRecording(true);
      this.props.speech.stopListening();
      this.clearTimingVariables();
      return Promise.resolve(this.setState({
        testTimeExpired:false
      }));
      //TODO: leave this code in for now. Remove if we decide we never want to save aborted assessments
      /*return studentRecordService.markCompleted(this.state.activityId) //TODO mark with a different status
      .then(()=>{
        this.sendEndOfStoryRecording();

        calculatePhraseSplits(timings,this.props.story.storyId,stopTime)
        .then(splits => {
          saveAssessmentTiming(this.state.activityId,splits);
        })
        .catch(err=>{
          console.log(err);
          logSentryException(err, "Error calculating phrase splits");
        });
        this.clearTimingVariables();
        this.setState({
          testTimeExpired:false
        });
      });*/
    }else{
      this.clearTimingVariables();
      return Promise.resolve(this.setState({
        testTimeExpired:false
      }));
    }
  }

  onPageEnd(phrases,didIntervene = false){
    const {assessmentPageNavEnabled} = getUserData();
    if(!this.state.minTimeElapsed && !assessmentPageNavEnabled){
      return;
    }

   if(this.props.story && this.props.story.type === assignmentTypes.ASSESSMENT){
      //if we are at the end of the first page or if we haven't checked for downleveling yet, check whether we need to relevel the story
      if((this.props.pageIndex == 0 || !this.state.frustrationLevelChecked) && this.props.orfMode && !isEarlyReaderMode(this.state.earlyReaderMode) && !this.state.testTimeExpired){
        //If the reader less than ten words in on the first page and clicks next,
        //skip accuracy based re-level logic and go to the next page. The re-level time remains active.
        //If the reader is more than 10 words deep on the first page, we'll use the accuracy up to the
        //currentWordIndex to decide whether to re-level or not.
        if((this.props.pageIndex == 0) && (this.state.currentWordIndex < 10) && assessmentPageNavEnabled && (this.props.pageIndex < this.props.story.pages.length-1)){
          this.goToNextPage();
          return;
        }else{
          let {errors} = this.state;
          if(assessmentPageNavEnabled){
            const currentPhraseErrors = errors[this.props.pageIndex][this.state.currentPhraseIndex];
            if(currentPhraseErrors.cleanTranscript){
              errors[this.props.pageIndex][this.state.currentPhraseIndex].totalErrors = currentPhraseErrors.totalErrors.slice(0, currentPhraseErrors.cleanTranscript.length);
            }else{
              //Handle case where the student hasn't said anything
              errors[this.props.pageIndex][this.state.currentPhraseIndex].totalErrors = [true];
            }

          }
          this.setState({frustrationLevelChecked: true});
          if(this.checkFrustrationLevel(errors)){
          // no need to do the rest of these calculations if we are re-leveling
            return;
          }

          //Because of the slicing above, also fire if they have < 8 words correct
          let wordsCorrect = this.getCurrentPhraseErrors().reduce((total,error)=>{
            return error ? total : total+1;
          },0);

          let studentGrade = getUserData().actualGrade;
          let storyGrade = parseInt(this.props.story.grade);

          logSessionInfo('downlevel_check', {
            src: 'onPageEnd',
            wordsCorrect,
            errors,
            currentPhraseErrors: this.getCurrentPhraseErrors(),
            studentGrade,
            storyGrade,
          });

          //downlevel if the student has not read 8 words
          //and the student has not upleveled
          if(wordsCorrect < 8 && storyGrade <= studentGrade){
            logSessionInfo('downlevel', {
              src: 'onPageEnd',
              wordsCorrect,
              errors,
              currentPhraseErrors: this.getCurrentPhraseErrors(),
              studentGrade,
              storyGrade,
            });
            this.reLevel("long_pause");
            return;
          }
          else{
            let {wcpm} = calculateMostRecentScores(errors, getAudioDuration());
            const locale = isSpanishStory(this.props.story) ? "es-mx" : "en-us";
            let wcpmPR = getWCPMGradePR(wcpm, this.props.story.grade, locale);

            logSessionInfo('uplevel_check', {
              src: 'onPageEnd',
              errors,
              wcpm,
              wcpmPR,
              locale,
            });

            //up level story if the student's wcpm is above 95% of the PR for the story's grade
            //and the student has not been downleveled
            if(wcpmPR >= 95 && storyGrade >= studentGrade && storyGrade < 6){
              logSessionInfo('uplevel', {
                src: 'onPageEnd',
                errors,
                wcpm,
                wcpmPR,
                locale,
              });
              this.reLevel("above_grade_level");
              return;
            }
          }
        }
      }
    }

    //This checks to make sure that we're actually at the end of a page before executing any logic
    //(Root cause of this bug has been fixed, but leaving this here for error handling in case another situation arises)
    let tempPhrases = this.getCurrentPage();
    // This line checks to see if the current phrase index is less than the number of phrases on the page (IOW, that we
    // aren't calling PageEnd before the actual end of the page) unless we're in assessment mode and the test timer
    // has expired.
    if((this.state.currentPhraseIndex < tempPhrases.length - 1) && !this.state.testTimeExpired){
      console.log("HIT PAGE END IN MIDDLE OF PAGE:",tempPhrases,this.state.currentPhraseIndex);
      console.log(new Error().stack);
      logSessionInfo("hit_page_end_mid_page",{tempPhrases: tempPhrases, pageIndex: this.props.pageIndex, callbackAfterIntervention: !!this.state.callbackAfterIntervention});
      return;
    }

    if((this.props.pageIndex >= this.props.story.pages.length-1) || this.state.testTimeExpired){
      //END OF STORY
      this.playEndOfPhraseSequence(this.onStoryEnd);
    } else {
      //END OF PAGE
      this.playEndOfPhraseSequence(this.goToNextPage);
    }
  }

  async playEndOfPhraseSequence(callback){
    if(this.props.endingSequence.length){
      // loop through the ending sequence and play each one asynchronously
      const endingSequence = [...this.props.endingSequence];
      for await (const ending of endingSequence) {
        try{
          if(ending.textToSpeak){
            await this.props.speech.speakWithPromise({
              textToSpeak: ending.textToSpeak,
            });
          }else if(ending.url && ending.key){
            await this.props.speech.playAppSoundsWithPromise({
              url: ending.url,
              key: ending.key,
            });
          }else if(ending.phonemeToSpeak){
            const url = findFilenames(ending.phonemeToSpeak)
            await this.props.speech.playAppSoundsWithPromise({
              url,
              key: ending.phonemeToSpeak,
            });
          }
        }catch(err){
          console.log(err);
          logSentryException(err, "Error playing end of phrase sequence");
        }
      }
      this.props.clearEndingSequence();
    }
    callback()
  }

  goToNextPage(){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.PAGE_INCREMENT, page: this.props.pageIndex, });
    if(!this.state.minTimeElapsed){
      return;
    }
    this.nextPhrase(); //TODO: Make sure we're not doing this twice in this flow
    this.props.goToNextPage(); //TODO make nextPhrase call goToNextPage
  }

  //function to be called when the reader finishes reading a phrase and we are ready to move on to the next one
  // initiates the read aloud intervention if necessary, decides whether to try again or advance the phrase index
  onPhraseEnd(isRecording){
    if(!this.state.minTimeElapsed && !this.props.story.nonAudio){
      this.setState({phraseComplete: {isRecording: isRecording}});
      return;
    }

    if (this.networkMonitoringService) {
      this.networkMonitoringService.handlePhraseEnd();
    }

    //Log the final transcript so we can see what the speech rec thought we got in case of errors
    console.log("Transcript:",this.props.transcript.interim); //TODO: Remove once confident in error detection
    logSessionInfo("transcript_phrase_"+ overallPhraseIndex,timings);
    logSessionInfo("wav2vec_phonemes_"+overallPhraseIndex,wav2vecPhonemes);
    // first save the audio for this phrase
    if(this.props.speech){
      if(!this.state.retry && process.env.STREAM){
        this.setState({ phraseEnded: true });
        let phraseScore = this.getCurrentPhraseScore();
        let transcript = this.props.transcript.interim;
        if(this.props.transcript.interim){
          transcript = unidecode(this.props.transcript.interim);
        }
        let recordingMeta = {
          transcript: transcript,
          skips: phraseScore.skips,
          confidence: phraseScore.confidence,
          intervention_data: this.getInterventionSelectionV2Params(),
        };
        this.props.speech.disableRecording(this.props.config.assessmentMode ? false:true, recordingMeta);
        lastRecordingStop = Date.now();
        errordelay = Date.now();
        console.log("END OF PHRASE",errordelay); //TODO: Remove once confident in error detection
      }

      this.props.speech.stopListening();
      this.props.speech.resetTranscript();
    }

    this.clearInterventionTimer();
    this.stopRelevelTimer();
    this.phraseTimeoutRef.current && window.clearTimeout(this.phraseTimeoutRef.current);
    this.phraseTimeoutRef.current = null;

    if(this.props.config.assessmentMode || !process.env.STREAM){
      this.onErrorsAreValid(); //TODO: Separate other end of phrase logic from onErrorsAreValid so that it doesn't need to be called here
    } else {
      edmTimeout = window.setTimeout(this.onErrorsAreValid.bind(this),5000);
    }
  }


  updateDelays(){
    lastDelay = (Date.now()-errordelay)/1000;
    phraseDelays.push(lastDelay);
    let sum = 0;
    for(let i=0;i<phraseDelays.length;i++){
      sum += phraseDelays[i];
    }
    averageDelay = sum/phraseDelays.length;

    //console.log("ROUND TRIP TOOK ",lastDelay," SECONDS"); //TODO: Remove once confident in error detection

  }

  updateFrameTime(inASROutput){
    if(!this.props.story || !this.props.story.phrases) return;
    let frames = calculateFrameTime(this.props.story.phrases[overallPhraseIndex],inASROutput);
    frames.overallPhraseIndex = overallPhraseIndex;
    this.setState({frameTimes: frames});
  }

  onDetectionEnd(detectionResults) {
    this.setState({
      detections: detectionResults
    })
  }

  onErrorsAreValid(newErrors,confidenceLevels,phraseInterventionWeights) {
    if((!this.state.endOfPhrase || handledErrors) && newErrors){
      console.warn("GOT RESULTS IN MIDDLE OF PHRASE",this.state.endOfPhrase,handledErrors,newErrors);
      let logString = "errors_mid_page_phrase_"+ (overallPhraseIndex-1);
      logSessionInfo(logString,{endOfPhrase: this.state.endOfPhrase,handled: handledErrors,newErrors: newErrors, confidenceLevels: confidenceLevels});
      return;
    }

    if(newErrors && overallPhraseIndex >= newErrors.length){
      console.warn("ERRORS FROM PREVIOUS PHRASE",newErrors.length);
      logSessionInfo("errors_from_previous_phrase_"+newErrors.length,{errors: newErrors,currentPhrase: overallPhraseIndex});
      return;
    }

    if(edmTimeout){
      window.clearTimeout(edmTimeout);
      edmTimeout = null;
    }

    handledErrors = true;
    this.updateDelays();
    let clientErrors = this.getCurrentPhraseErrors();
    let currentErrors=[];
    let gotErrorsFromBackend = false;
    let overAllErrors = null;

    //Initialize the confidence value as an array of the same length as the error array initialized to 0.

    let confidence = confidenceLevels ? confidenceLevels : Array(clientErrors.length).fill(0);
    predictionConfidences.push(confidence);

    //Replicate the behavior of inference service for tutors. We mark in progress at the end of every phrase
    // so that we can derive session time for abandoned activities
    if(!this.props.config.assessmentMode){
      studentRecordService.markInprogress(this.state.activityId);
    }

    // split out the words so that we can check whether or not any of them are phonemes. For now,
    //  we don't want to use the end of phrase EDM for phrases that contain phonemes when we have
    //  phoneme placement enabled because EDM does not support phoneme listening and will mess up
    //  our errors array
    let phrases = this.getCurrentPage();
    let phrase = phrases[this.state.currentPhraseIndex];
    let words = cleanAndSplit(phrase);

    if(newErrors) {
      logSessionInfo("edm_errors_phrase_"+ overallPhraseIndex,newErrors);
      currentErrors = newErrors[overallPhraseIndex];

      if(currentErrors){
        gotErrorsFromBackend = true;
        if(!clientErrors.length){
          console.log('Error array of length 0: ',this.state.errors,overallPhraseIndex);
          logSessionInfo("zero_length_errors",{errors: this.state.errors,overallPhraseIndex});
          Sentry.captureMessage("Zero Length Errors");
        }
      }else{
        currentErrors=this.getCurrentPhraseErrors();
      }

    }else{
      currentErrors=this.getCurrentPhraseErrors();
    }

    // Track if the phrase is all phonemes, because we don't want to flag these phrases regardless of edm returning or not
    let phraseIsAllPhonemes = true;
        // Override all phonemes from placement manager.  EDM does not support phonemes, and they would be incorrect if we used what EDM says.
    for(let i = 0; i < words.length; i++){
      const word = words[i];
      if(isPhoneme(word)){
        currentErrors[i] = clientErrors[i];
      } else {
        phraseIsAllPhonemes = false;
      }
    };

    let errorsForInterventions = JSON.parse(JSON.stringify(currentErrors));
    let closeErrors = [];

    //Don't change app state on a retry (IOW if this is a readback)
    if(!this.state.retry){
      overallPosition += words.length;

      //TODO: pull this into a method
      //Calculate placement timings at the end of the phrase
      if(!this.state.testTimeExpired){
        let timingObject = {
          position: overallPosition,
          word: words[words.length-1],
          time: new Date().getTime() - totalTimeSpentIntervening - recordingStart - timeBetweenPages - this.props.speech.silentSegments().timingOffset,
          overallPhraseIndex
        }
        timings.push(timingObject);
      }

      if(!this.props.config.assessmentMode){
        // If we got errors from the backend, we need to exclude stop words from the potential errors for interventions.
        // If we got no errors from the backend, we need to assume that the student got everything correct so we don't intervene.
        for(let i=0; i<words.length; i++){
          if(gotErrorsFromBackend){
            errorsForInterventions[i] = this.finalizeError(words[i],currentErrors[i]);
          }else{
            errorsForInterventions[i]=false;
            currentErrors[i] = false; //If we got no answer from EDM, assume student got everything right.
          }
        }

        //CLIENT OVERRIDES - set errors based on skips and interventions
        //Cheat and use skips from the front end
        let skips = this.getCurrentPhraseScore().skips;
        this.state.storyInterventions[overallPhraseIndex].map((intervened,index)=>{
          let override = intervened;
          if(skips && index < skips.length && skips[index] && !isSpanishStory(this.props.story)){
            override = true;
          }
          if(override){
            currentErrors[index] = true;
          }
        });
      }

      if(!gotErrorsFromBackend && !this.props.config.assessmentMode && !phraseIsAllPhonemes){
        // Flag the current phrase for review when EDM doesn't respond
        studentRecordService.updateFlaggedPhrase(this.state.activityId, overallPhraseIndex, true);
        console.log("No errors from backend. Using",JSON.stringify(currentErrors));
        logSessionInfo("no_errors_from_backend_phrase_"+overallPhraseIndex,{errors: currentErrors});
      } else if (phrasesWithAutoProgressedWords[overallPhraseIndex]) {
        // Flag the current phrase for review if we auto-progressed any words
        studentRecordService.updateFlaggedPhrase(this.state.activityId, overallPhraseIndex, true);
      }

      //Get the transcript from the Google EDM and align it so we can get close errors independantly of placement manager.
      let transcript = scoreTranscript(phrase,{interim: getUnconstrainedTranscript()}, this.state.currentWordIndex, this.state.matchThreshold,
      this.props.config.numMatchWords,this.props.config.matchWindow, this.props.config.assessmentMode).cleanTranscript;
      logSessionInfo("unconstrained_transcript_phrase_"+overallPhraseIndex,transcript);

      if(words){
        currentErrors.map((error,index)=>{
          if(error){
            let utteredWord = (transcript && transcript[index]) ? transcript[index] : null;
            let desiredWord = (words && words[index]) ? words[index] : null;
            if((utteredWord && desiredWord) && (utteredWord !== desiredWord)){
              let closeError = {
                index: index,
                utteredWord: utteredWord,
                desiredWord: desiredWord,
              };
              closeErrors.push(closeError);
            }
          }
        });
      }

      overAllErrors = this.setCurrentPhraseErrors(currentErrors,true);
      let errorCount = this.state.errorCount;
      let currentErrorCount = 0;

      let studentPauseTime = this.getStudentPauseTime();

      for(let i = 0; i < currentErrors.length; i++){
        if(currentErrors[i]){
          currentErrorCount += 1;
        }
      }

      //Save the errors for this phrase
      errorCount[overallPhraseIndex] = currentErrorCount;

      this.setState({
        errorCount: errorCount,
        pauseLength: studentPauseTime,
        isFinal: true,
        savedPhraseErrors: currentErrors,
      });
    }else if(this.state.savedPhraseErrors){
      overAllErrors = this.setCurrentPhraseErrors(this.state.savedPhraseErrors,true);
    }

    // check track of most recent WPM and accuracy
    const mostRecentScores = calculateMostRecentScores(overAllErrors, getAudioDuration());
    if((this.state.currentPhraseIndex >= phrases.length - 1) || this.state.testTimeExpired){
      // END OF PAGE.
      // Do any end of phrase interventions and then hit end of page when they're done
      const sessionInfo = {cursorPosition: this.state.currentWordIndex, phraseLength: words.length, timeStamp: Date.now(),}
      // Always call onPageEnd if test time has expired.
      if(this.state.testTimeExpired){
        logSessionInfo("assessment_time_expired_page_end", sessionInfo);
        this.onPageEnd(phrases);
      }else if(this.props.config.assessmentMode){
        logSessionInfo("assessment_cursor_page_end", sessionInfo);
        // If page nav is enabled, defer calling onPageEnd to onNextPageClick because we don't want to automatically advance the page.
        this.onPageEnd(phrases);
      }else{
        if(this.state.earlyReaderMode && this.state.earlyReaderMode.wordList){
          logSessionInfo("early_reader_word_list_page_end", sessionInfo);
        }
        let callbackAfterIntervention = (currentPhrases, didIntervene=false) => {
          this.onPageEnd(currentPhrases, didIntervene);
          this.setState({
            callbackAfterIntervention: null,
            interveningAtEndOfPage: false,
          });
        }
        this.setState({
          callbackAfterIntervention: !this.state.testTimeExpired ? callbackAfterIntervention.bind(this,phrases,true) : null,
          interveningAtEndOfPage: !this.state.testTimeExpired,
        }, () =>{
          this.handleEndOfPhraseInterventions(
            mostRecentScores,
            closeErrors,
            errorsForInterventions,
            phraseInterventionWeights
          ).then(didIntervene => {
            if((didIntervene) && (this.state.testTimeExpired == false)){
              logSessionInfo("delayed_page_end",{phraseIndex: overallPhraseIndex, newErrors: newErrors});
            }else{
              let delayedPageEnd = ((phrases)=>{
                callbackAfterIntervention(phrases);
              }).bind(this,phrases);
              window.setTimeout(delayedPageEnd,1500);
            }
          });
        });
      }
    }else{
      //END OF PHRASE
      this.handleEndOfPhraseInterventions(
        mostRecentScores,
        closeErrors,
        errorsForInterventions,
        phraseInterventionWeights
      ).then((intervened)=>{
        if(!intervened){
          this.abortIntervention();
        }else{
          logSessionInfo("delayed_phrase_end",{phraseIndex: overallPhraseIndex, newErrors: newErrors});
        }
      });
    }
  }

  //This method gets the amount of time we should wait before doing an intervention in the middle of a phrase.
  getStudentPauseTime(){
    if(this.props.config.assessmentMode){
      return 4000;  //Always 4 seconds for anything that pops up during assessment
    }
    let studentLevel = getStudentReadingLevel();
    let studentPauseTime = this.props.config.beginnerPauseTime;
    if(studentLevel === readingLevels.capable){
      studentPauseTime = this.props.config.mediumReaderPauseTime;
    }
    else if(studentLevel === readingLevels.proficient){
      studentPauseTime = this.props.config.fastReaderPauseTime;
    }

    // For early readers, crank out the pause time by 2 seconds. TODO: tune this.
    if(isEarlyReaderMode(this.state.earlyReaderMode)){
      studentPauseTime += 2000;
    }
    return studentPauseTime;
  }

  // returns true if phoneme placement is enabled and also the current word is a phoneme
  shouldListenForPhonemes(word=null){
    const currentWord = word || this.getCurrentWord(this.state.currentWordIndex);
    return this.props.speech.getPhonemePlacementEnabled() && isPhoneme(currentWord);
  }

  async handleEndOfPhraseInterventions(
    mostRecentScores,
    closeErrors,
    currentErrors,
    phraseInterventionWeights
  ){
    let errorsInPhrase = this.getWordErrors(currentErrors);
    let currentErrorCount = errorsInPhrase.length;
    let didIntervene = false;

    //If interventions are disabled, just return
    if(!this.props.config.enableInterventions || (this.state.retry && !getIsInReadWithMeMode())  || this.disableInterventionsForPhrase){
      return Promise.resolve(didIntervene);
    }
    // Handle interaction scenario override
    const phraseMetadata = this.getCurrentPhraseMetaData();
    if (phraseMetadata && phraseMetadata.type === 'interactive') {
      await this.launchInteraction();
      this.props.closeModal();
      await new Promise((resolve) => {
        setTimeout(() => { resolve() }, 200);
      });
      moveOnWithoutSpeaking(
        this.openWordInterventionModal, // callback
        true, // endOfPhrase
      );
      return (Promise.resolve(true));
    }
    let currentPhraseLength = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]).length;
    let skips = this.getCurrentPhraseScore().skips;
    return selectPhraseIntervention({
      currentErrorCount: currentErrorCount,
      errorsInPhrase: errorsInPhrase,
      mostRecentScores: mostRecentScores,
      currentPhraseLength: currentPhraseLength,
      closeErrors: closeErrors,
      skips: skips,
      frameTimes: this.state.frameTimes,
      forceIntervention: this.props.forceIntervention,
      phraseMetaData: this.getCurrentPhraseMetaData(),
      predictionConfidences: predictionConfidences[overallPhraseIndex],
      phraseInterventionWeights,
      story: this.props.story,
    }).then(async (phraseIntervention)=>{
      console.log('interior phrase', [phraseIntervention,this.state.lastWordInterventionIndex, (currentPhraseLength-1)] );
      phraseIntervention.word = this.getCurrentWord(phraseIntervention.index, true);

      this.setState({
          lastWordError: phraseIntervention.word,
          lastWordIndex: phraseIntervention.index
        },
      )

      // This is where we do the hack to not intervene if we already did on the last word
      // TODO consider how to make this cleaner. One approach (which Pete disagrees with) would be
      // to consolidate intervention history and state across interventionSelection and ReaderManager,
      // probably by creating a class to represent state and more fully embracing OOP

      //Do it this way so we can log situations where preflight fails
      let validIntervention = true;
      if(preflightIntervention(phraseIntervention.word,phraseIntervention) === false){
        console.log("FAILED PREFLIGHT:",phraseIntervention.word,phraseIntervention);
        logSessionInfo("failed_preflight",{word: phraseIntervention.word, intervention: phraseIntervention});
        validIntervention = false;
      }

      if(!validIntervention ||
        (((this.state.lastWordInterventionIndex === (currentPhraseLength-1)) && !isEarlyReaderMode(this.state.earlyReaderMode)) ||
        (alreadyIntervened(phraseIntervention.word) == true))){
        if(phraseIntervention.type !== interventionType.repeatsentence && phraseIntervention.type !== interventionType.initiateReadWithMe && phraseIntervention.type !== interventionType.readwithme && phraseIntervention.type !== interventionType.endReadWithMe) {
          phraseIntervention = {
            word: "OverrideLastWord",
            type: interventionType.none,
          };
        }
      }

      if(phraseIntervention.scope !== scopeType.phrase && phraseIntervention.word && phraseIntervention.type !== interventionType.none){
        try{
          let success = await this.launchWordIntervention(phraseIntervention.word,mostRecentScores,true,phraseIntervention);
          didIntervene = success;
          console.log("LAUNCH RETURNED",didIntervene);
        }catch(err){
          console.log("ERROR EXECUTING PHRASE INTERVENTION:",err);
          logSessionInfo(err.name + " " + err.message,{error: err.stack});
          logSentryException(err, "Error executing phrase intervention");
          didIntervene = false;
        }
      } else if (phraseIntervention.type === interventionType.comprehension || phraseIntervention.type === interventionType.prediction){
        try{
          phraseIntervention.word = !phraseIntervention.word ? `${phraseIntervention.type}_NO_ERRORS` : phraseIntervention.word;
          let success = await this.launchWordIntervention(phraseIntervention.word,mostRecentScores,true,phraseIntervention); //TODO: consolidate these calls and rename launchWordIntervention to make it scope agnostic (launch modal intervention  maybe)
          didIntervene = success;
          console.log("LAUNCH RETURNED",didIntervene);
        }catch(err){
          console.log("ERROR EXECUTING PHRASE INTERVENTION:",err);
          logSessionInfo(err.name + " " + err.message,{error: err.stack});
          logSentryException(err, "Error executing phrase intervention");
          didIntervene = false;
        }
      } else if(phraseIntervention.word) {
        didIntervene = this.triggerEndOfPhraseInterventions(phraseIntervention.type,currentErrorCount,phraseIntervention.word,phraseIntervention.index);
      } else {
        didIntervene = false;
      }

      onPhraseInterventionSelected(phraseIntervention);
      return Promise.resolve(didIntervene);
    })
    .catch(err => {
      console.log("ERROR IN END OF PHRASE:",err);
      logSessionInfo(err.name + " " + err.message,{error: err.stack});
      logSentryException(err, "Error in end of phrase");
      return Promise.resolve(false);
    });
  }

  displayStudentStatus(timed = false){
    let activityId = this.props.config.assessmentMode ? null : this.state.activityId;

    getStudentMetrics(activityId, true).then(resp =>{
      this.props.speech.stopListening();

      if (resp.currentWCPM) {
        setUserData("WCPM", resp.currentWCPM);
        setUserData("interventionSelectionWCPMScore", resp.currentWCPM);
      }

      if (resp.currentARMScore) {
        setUserData("interventionSelectionARMScore", resp.currentARMScore);
      }

      let currentMetrics=resp.currentWCPM ?
      {wcpm: resp.currentWCPM, accuracy: resp.currentAccuracy} :
      {wcpm: this.state.wcpm, accuracy: this.state.accuracy};

      //If we didn't get current metrics, log this fact to the backend
      if(!resp.currentWCPM || !resp.currentAccuracy){
        resp.currentWCPM = this.state.wcpm;
        resp.currentAccuracy = this.state.accuracy;
        logSessionInfo('metrics_activity_was_not_scored',resp);
      }

      let ssType = studentStatusTypes.STORY;
      if(timed){
        ssType = studentStatusTypes.TIMED;
      } else if(this.props.config.assessmentMode){
        if(this.props.orfMode){
          ssType = studentStatusTypes.ASSESSMENT;
        } else {
          ssType = studentStatusTypes.GENERIC;
        }
      }

      this.openModalAndStopListening(
        <StudentStatus
          currentMetrics={currentMetrics}
          historicMetrics={resp}
          speech={this.props.speech}
          history={this.props.history}
          type={ssType}
          showStats={!this.props.config.assessmentMode}
          redirect={!this.props.config.assessmentMode}
        />
      );
    });
  }

  displayEarlyReaderStatus(){
    this.openModalAndStopListening(
      <EarlyReaderStatus
        speech={this.props.speech}
        history={this.props.history}
      />
    );
  }

  onSubmitQuiz(){
    this.props.closeModal();
    if(!isSendingComplete()){
      this.openWaitModal(this.finalizeTutor);
    }else{
      this.finalizeTutor();
    }
  }

  sendEndOfStoryRecording(){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.SEND_RECORDING });
    if(this.props.speech){
      this.props.speech.disableRecording();
      this.props.speech.stopListening();
      let recordingProps ={
        storyId: this.props.story.storyId,
        storyVersion: this.props.story.version || "1",
        version: this.props.story.version || "1",
        activityType: this.props.story.type,
        activityId: this.state.activityId,
        studentId: getUserData().userId,
        flagPhrase: getIsInReadWithMeMode(),
      };

      buildSessionAudio(this.state.activityId,recordingProps);
      logSessionInfo("glitch_metrics",this.props.speech.silentSegments());
    }
  }

  updateScoring(){
    const { storyErrors, accuracy, wcpm } = calculateMostRecentScores(this.state.errors, getAudioDuration());
    this.setState({wcpm,accuracy});
    return { storyErrors, accuracy, wcpm }
  }

  async onStoryEnd(){
    setUseGenerativeVoiceGlobal(false);

    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.STORY_END });
    this.props.logTimeOnStoryEnd();//Log the time when the story ends
    logSessionInfo("placement_logs",timings);
    if (this.networkMonitoringService) {
      logSessionInfo("activity_network_health", {
        badCount: this.networkMonitoringService.badNetworkCount,
        activityId: this.state.activityId
      });
    }
    if(this.props.config.assessmentMode || this.state.testTimeExpired){
      this.handleEndOfAssessment();
    }else if(this.props.asrStoryID){
      this.updateScoring();
      this.clearTimingVariables();
      this.sendEndOfStoryRecording();
      endEDMSession();
      studentRecordService.markArchived(this.state.activityId); //We don't want this activity to "count" in any way
      if(this.props.onEndASRCheck){
        this.props.onEndASRCheck()
      }
    }else{
      //For tutors, calculate metrics to use as a fallback if the backend doesn't score in time for the Status Screen
      const { storyErrors } = this.updateScoring();

      studentRecordService.scoreTutoring(this.state.activityId,storyErrors,getAudioDuration(),this.state.storyInterventions);
      let storySkips = [];
      this.state.errors.forEach((page)=>{
        page.forEach((phrase)=>{
          storySkips.push(phrase.skips);
        });
      });

      if(getUserData().iesEnabled) {
        // Setup base data object
        const body = {
          activityId: this.state.activityId,
          iesEnabled: getUserData().iesEnabled,
          audioDuration: getAudioDuration(),
          storySkips: storySkips,
          storyId: this.props.story.storyId,
          storyVersion: this.props.story.version || "1",
          activityType: this.props.story.type,
          storyTitle: this.props.story.title,
          storyPhrases: this.props.story.phrases,
        }

        // Fetch parent portal access key
        try {
          const iesAccessKey = await getAccessKeyByStudentId(getUserData().userId);

          // If it exists, attach it
          if (iesAccessKey) {
            const {parentEmail, parentPhone} = iesAccessKey;
            if (parentEmail) {
              body.email = parentEmail;
            } else if (parentPhone) {
              body.email = `${parentPhone}@amira.com`;
            }
          }
        } catch (e) {
          console.log(`[IES] Error getting access key: ${e}`);
        }

        sendMessageToSqs(SEGMENT_EVENTS.story_completed, body);
      }

      if(this.isEarlyReader()){
        updateErssStatus(getUserData().userId,this.state.activityId,this.props.story.tags,"COMPLETED")
      }

      logSessionInfo("scored_tutor",{errors: storyErrors});
      logSessionInfo("skips",storySkips);
      this.clearTimingVariables();
      this.sendEndOfStoryRecording();
      endEDMSession();

      if(getUserData().startingEarlyReaderSequence){
        clearEarlyReaderSequenceStart(getUserData().locale);
      }

      //If we have questions to display to the student, do it here
      //Otherwise, skip to the end of story modal.
      if(Array.isArray(this.props.questions) && this.props.questions.length > 0){
        //NOTE this isn't how we do it anymore, this is for backward compatibility
        let modalContent = (
          <Quiz
            speech={this.props.speech}
            questions={this.props.questions}
            readQuestionDefault={true}
            feedbackModeDefault={true}
            onSubmit={this.onSubmitQuiz}
            sendMessage={this.props.sendMessage.bind(this)}
          />
        );
        this.openModalAndStopListening(
          modalContent,
          {
            delayedCloseButton: true,
            close: () => {
              this.props.speech.abortSpeech(this.onSubmitQuiz.bind(this));
            }
          }
        );
      }else{
        this.openWaitModal(this.finalizeTutor);
      }
    }
    this.setState({storyInProgress: false, storyEnded: true})
  }

  triggerEndOfPhraseInterventions(type,currentErrorCount,lastWordError,lastWordIndex){
    this.props.logReaderManagerEvents({type: ReaderManagerEventConstants.INTERVENTION_ON_PHRASE });
    switch(type){
      case interventionType.read:
        speakInterventionLeadIn(this.props.speech, interventionType.read);
        this.readAloudWithCallback(this.tryAgain.bind(this));
        return true;
        break;
      case interventionType.clap:
        let wordToUse = "";
        wordToUse = lastWordError.replace(/[.,\/#!$%\^&\*;:{}=\-_`'~()""?!]/g, "");
        this.playRepeatAfterMe(wordToUse,lastWordIndex);
        return true;
        break;
      case interventionType.toofast:
        // if this is the last phrase of the story, skip this intervention
        // TODO: consider whether this logic should be encapulated within interventionSelection
        if(this.state.currentPhraseIndex === (this.getCurrentPage().length - 1) && this.props.pageIndex == this.props.story.pages.length - 1) {
          return false;
        }
        let props = {};
        props.text = getTooFastPhrases();
        props.callback = (
          function(event){
            this.cleanUpAfterIntervention();
          }
        ).bind(this);

        this.props.sendMessage(props);
        return true;
        break;
      case interventionType.repeatsentence:
        speakInterventionLeadIn(this.props.speech, interventionType.repeatsentence,lastWordError.replace(/[.,\/#!$%\^&\*;:{}=\-_`'~()""?!]/g, ""));
        this.readAloudWithCallback(() => {
          this.props.speech.speak({textToSpeak: getKeepReading(getStudentReadingLevel), onEnd: this.cleanUpAfterIntervention.bind(this)});
        });
        return true;
      case interventionType.readwithme:
        this.readWithMe();
        return true;
      case interventionType.initiateReadWithMe:
        // Don't read with me if this is last phrase
        if (this.props.story && this.props.story.phrases && overallPhraseIndex < this.props.story.phrases.length - 1) {
          this.initiateReadWithMeMode();
          return true;
        } else {
          console.log("Attempted to do initiateReadWithMe, but since this is the last phrase of story, we will skip");
          return false;
        }
      case interventionType.endReadWithMe:
        // Don't read with me if this is last phrase
        if (this.props.story && this.props.story.phrases && overallPhraseIndex < this.props.story.phrases.length - 1) {
          this.endReadWithMeMode();
          return true;
        } else {
          console.log("Attempted to do endReadWithMe, but since this is the last phrase of story, we will skip");
          return false;
        }
      default:
        return false;
    }
  }

  //This method is called after the end of phrase interventions
  // and handles a lot of the housekeeping for cleaning up the intervention
  // state and getting ready for the next phrase (or page)
  cleanUpAfterIntervention(){
    if(!this.state.endOfPhrase){
      return;
    }

    isWordInterventionInProcess = false;

    //Clean up state related to running the clap intervention
    this.setState({
      repeateAfterMeInterventionInProcess: false,
      interventionWordIndex: -1,
      interventionWord: null,
    });
    if(this.state.callbackAfterIntervention){
      this.state.callbackAfterIntervention();
    } else {
      this.nextPhrase();
    }
  }

  getClapInterventionComponent(){
    let wordMetadata = this.props.currentWordMetadata;

    if (
      this.props.currentPhraseWordMetadata &&
      this.state.interventionWordIndex > -1
    ) {
      wordMetadata = this.props.currentPhraseWordMetadata[this.state.interventionWordIndex];
    }

    return(
      <RepeatAfterMe
        coachIsReady={this.props.coachIsReady}
        speech={this.props.speech}
        sendMessage={this.props.sendMessage}
        setSpeech={this.props.setSpeech}
        setTranscript={this.props.setTranscript}
        wordToPractice={this.state.interventionWord}
        wordMetadata={wordMetadata}
        stopIntervention={() => {
          if (this.state.endOfPhrase) {
            this.cleanUpAfterIntervention();
          } else {
            this.onInterventionEnd();
          }
        }}
        openModal={this.openModal}
        closeModal={this.props.closeModal}
        readingLevel={getStudentReadingLevel()}
      />
    );
  }

  setTextResponse(response, final=false){
    //every time we update the textresponse, reset the phrase timeout so that we don't time out while the kid is typing
    // NOTE: if we ever start calling setTextResponse for any other reason than input from the child, separate these concerns
    this.startPhraseTimeout(); // start clears the timeout

    response = response || " ";
    let textResponse = response.response || response;
    let cleanResponse = textResponse.replace(/[^a-zA-Z ]/g, "_");
    let currentResponses = this.state.textResponse; //TODO change this to `textResponses`
    let currentPageResponses = currentResponses[this.props.pageIndex] || [];
    currentPageResponses[this.state.currentPhraseIndex] = cleanResponse;
    currentResponses[this.props.pageIndex] = currentPageResponses;

    let currentWord = this.getCurrentWord();

    let currentPhrase = this.getCurrentPage()[this.state.currentPhraseIndex];
    let cleanCurrentPhrase = currentPhrase.replace(/[^a-zA-Z ]/g, "_");

    let currentErrors = this.state.simpleErrors;
    let currentPageErrors = currentErrors[this.props.pageIndex] || [];
    currentPageErrors[this.state.currentPhraseIndex] = ((currentWord.toLowerCase() != cleanResponse.toLowerCase()) && (cleanCurrentPhrase.toLowerCase() != cleanResponse.toLowerCase()));
    currentErrors[this.props.pageIndex] = currentPageErrors;

    this.setState({
      textResponse: currentResponses,
      simpleErrors: currentErrors,
    }, () => {
      if(final){
        this.onPhraseTimeout();
      }
    });
  }

  setPlacement(index){
    let currentErrors = this.getCurrentPhraseErrors();
    if (currentErrors.length - 1 > index){
      this.props.speech.stopListening();
      this.props.speech.resetTranscript();
      this.props.speech.startListening("setPlacement");
      currentErrors = currentErrors.slice(0, index);
    } else {
      // add errors for skipped words
      let numSkipped = index - currentErrors.length;
      for(let i = 0; i < numSkipped; i++){
        currentErrors.push(true);
      }
    }
    this.setCurrentPhraseErrors(currentErrors);
    // TODO set pause time if this method is ever used again
    this.setState({
      lastProgress: defaultLastProgress,
      currentWordIndex: index,
    });
  }

  setMatchThreshold(event){
    this.setState({
      matchThreshold: event.target.value,
    });
  }

  setPauseLength(event){
    this.setState({
      pauseLength: event.target.value,
    });
  }

  setGiveUpLength(event){
    this.setState({
      giveUpLength: event.target.value,
    });
  }

  isNextPhraseVideo(){
    return this.props.story && this.props.story.items && this.props.story.items[overallPhraseIndex + 1] && this.props.story.items[overallPhraseIndex + 1].type == "video";
  }

  getTestControls(){
    if(this.state.mounted && this.props.isTest){
      return(
        <div className="testControls">
          <div className="displayTranscript"><span className="label">Transcript: </span><span className = "transcript">{this.props.transcript.interim}</span></div>
          <div className="testControlForm">
            <span className="label">Match Threshold: </span>
            <span className="input">
              <input type="text" name="matchThreshold" value={this.state.matchThreshold} onChange={this.setMatchThreshold}/>
            </span>
            <span className="label">Modal Intervention Timeout: </span>
            <span className="input">
              <input type="text" name="modalTimeout" value={this.state.pauseLength} onChange={this.setPauseLength}/>
            </span>
            <span className="label">Simple Intervention Timeout: </span>
            <span className="input">
              <input type="text" name="simpleTimeout" value={this.state.giveUpLength} onChange={this.setGiveUpLength}/>
            </span>
          </div>
        </div>
      );
    }
  }

  getEndAssessmentButton(){
    if(this.props.config.assessmentMode && this.props.story && this.props.orfMode){
      return (
        <div className="endAssessmentButton" {...doNotUseAccessibleStaticElementInteractions({onClick: () => this.handleEndOfAssessment(statusType.ABORTED)})}>
          <div className="iconContainer"><img className="endIcon" src={end_assessment_image} alt="" /></div>
          <div className="buttonText">{COPY_STRINGS.end_assessment}</div>
        </div>
      );
    } else {
      return null;
    }
  }

  setPageNavRestrictedTimeout(){
    this.state.pageNavRestrictedTimeout && window.clearTimeout(this.state.pageNavRestrictedTimeout);
    return (this.props.story && this.props.orfMode && this.props.config.assessmentMode && getUserData().assessmentPageNavEnabled)
      ? window.setTimeout(this.onPageNavRestrictedTimeout.bind(this), 65000) : null;
  }

  onPageNavRestrictedTimeout(){
    logSessionInfo("assessment_page_nav_restricted_timeout_expired", {
      cursorPosition: this.state.currentWordIndex,
      phraseLength: cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]).length,
      timeStamp: Date.now(),
    });

    window.clearTimeout(this.state.pageNavRestrictedTimeout);
    this.setState({
      pageNavRestrictedTimeout: null,
      pageNavEnabled: true
    });
  }

  onNextPageClick() {
    const cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
    let phraseErrors = this.getCurrentPhraseErrors();
    //unless they're at the end of a phrase, ignore clicks for 5 seconds after
    //a registerd click to handle users mashing the next button.
    if((phraseErrors.length === cleanPhrase.length && !this.state.pageNavTriggered)
      || !this.state.pageNavLastClick || moment().diff(this.state.pageNavLastClick, 'seconds') >=5){
      this.setState({pageNavLastClick: moment()});

      logSessionInfo("assessment_next_page_clicked", {cursorPosition: this.state.currentWordIndex, phraseLength: cleanPhrase.length, timeStamp: Date.now(),});
      this.setState({pageNavTriggered: true});

      if(phraseErrors.length < cleanPhrase.length){ //reader didn't finish the current page
        this.props.speech.stopListening();

        //pad the errors array to account for the remaining words skipped by the reader
        const paddingErrors = Array(cleanPhrase.length - phraseErrors.length).fill(true);
        phraseErrors = phraseErrors.concat(paddingErrors);
        for(let i=0; i<cleanPhrase.length; i++){
          phraseErrors[i] = this.finalizeError(cleanPhrase[i],phraseErrors[i]);
        }
        this.setCurrentPhraseErrors(phraseErrors);

        if(!this.state.endOfPhrase){
          this.handlePotentialEndOfPhrase();
        }
      }

      this.onPhraseEnd(this.props.speech.isRecording());
    }
  }

  checkPageNavEnabled(){
    const cleanPhrase = cleanAndSplit(this.getCurrentPage()[this.state.currentPhraseIndex]);
    let phraseErrors = this.getCurrentPhraseErrors();
    if(phraseErrors.length >= (cleanPhrase.length-5)){
      this.setState({pageNavEnabled: true})
    }
  }

  getRepeatInstructions(){
    let phraseMetaData = this.getCurrentPhraseMetaData();
    if(this.props.skipIntros) return "Skipping Instructions";
    if(phraseMetaData.instructions
        && phraseMetaData.instructions.verbalInstructions
        && phraseMetaData.instructions.repeatable){
      return phraseMetaData.instructions.repeatVariation || phraseMetaData.instructions.verbalInstructions;
    } else {
      return null;
    }
  }

  getListeningStatusEnabled(){
    const story = this.props.story ? this.props.story : {};
    //TODO: Remove tutor condition when listening indicator is added to assessments (AE-4531)
    return !story.nonAudio
  }

  shouldDisablePictures(){
    let isEarlyReader = isEarlyReaderStory(this.props.story);
    return (this.props.story && (this.props.story.type === "tutor") && (
      (isEarlyReader && !getUserData().sorConfig.enableERPictures) ||
      (!isEarlyReader && !getUserData().sorConfig.enablePracticePictures)
    ));
  }

  handleNetworkStatusChange(oldStatus, newStatus) {
    const isTutor = this.props.story && this.props.story.type == assignmentTypes.TUTOR;
    if (!isTutor) {
      // Do nothing if this is not a tutor activity
      return;
    }

    if (newStatus === NetworkStatus.Bad) {
      const {
        WCPM,
      } = getUserData();

      const userSpecificReadRateMs = (60 / WCPM) * 1000;

      this.networkMonitoringService.logAnalytics("bad_network_auto_progress_state", {
        userSpecificReadRateMs
      });

      // How quickly we should auto-progress cursor when in bad network state
      const intervalTime = Math.min(Math.max(500, userSpecificReadRateMs), 2400); // WCPM based read rate, with 500ms min and 2400ms max

      badNetworkInterval = setInterval(() => {
        // If we are not yet at the end of the phrase, call skipWord to advance to the next word
        if (!this.state.endOfPhrase) {
          phrasesWithAutoProgressedWords[overallPhraseIndex] = true;

          this.skipWord(
            false, // sayWord
            true, // force
            true, // noError
          );
        }
      }, intervalTime);

      // Wait to enter pauseFromBadNetwork state until we have auto-progressed through 3 words, with a min time of 3000ms and max time of 5000ms
      const badNetworkPauseReadingTimeoutMs = Math.min(Math.max(intervalTime * 3, 3000), 5000);

      badNetworkPauseReadingTimeout = setTimeout(() => {
        if (badNetworkInterval) {
          window.clearInterval(badNetworkInterval);
          badNetworkInterval = undefined;
        }

        this.pauseFromBadNetwork();

        badNetworkPauseReadingTimeout = undefined;
      }, badNetworkPauseReadingTimeoutMs);
    } else {
      // We just entered normal network state

      if (badNetworkInterval) {
        this.resumeFromBadNetworkAutoProgress();
      }

      if (badNetworkPauseReadingTimeout) {
        window.clearTimeout(badNetworkPauseReadingTimeout);
        badNetworkPauseReadingTimeout = undefined;
      }

      if (badNetworkRetryPauseTimeout) {
        window.clearTimeout(badNetworkRetryPauseTimeout);
        badNetworkRetryPauseTimeout = undefined;
      }

      if (badNetworkCriticalTimeout) {
        window.clearTimeout(badNetworkCriticalTimeout);
        badNetworkCriticalTimeout = undefined;
      }

      if (this.state.pausedFromBadNetwork) {
        this.resumeFromBadNetworkPause();
      }

      badNetworkNeedsCriticalResponse = false;
    }
  }

  resumeFromBadNetworkAutoProgress() {
    if (badNetworkInterval) {
      window.clearInterval(badNetworkInterval);
      badNetworkInterval = undefined;
    }

    if (!this.state.endOfPhrase) {
      this.props.speech.stopListening("resumeFromBadNetworkAutoProgress", {
        onFinishCallback: () => {
          this.props.speech.startListening();
        }
      });
    }

    this.networkMonitoringService.logAnalytics("bad_network_resume_from_auto_progress_state");
  }

  pauseFromBadNetwork(skipSpeech = false) {
    this.setState({ pausedFromBadNetwork: true }, () => {
      this.openModal(
        <ErrorModal
          type={getErrorModalTypes().PAUSED_FROM_BAD_NETWORK}
          speech={this.props.speech}
          skipSpeech={skipSpeech}
        />,
        { logName: "bad_network_pause_state" }
      );

      this.state.noAudioTimer && window.clearTimeout(this.state.noAudioTimer);
      this.pausePhrase();
      this.props.speech.stopListening("pauseFromBadNetwork");

      // Stay in bad network pause state for at least 5 seconds before listening for good network again. 1 second if we are skipping speech
      setTimeout(() => {
        // Start listening to monitor speech queue for return to normal network, but skipCallback so we don't trigger cursor movement in the background
        this.props.speech.startListening(
          "pauseFromBadNetwork", // source
          null, // transcriptRequest, default is null
          true, // skipCallback
        )

        const pauseFailedTimeoutMs = 8000;

        if (!badNetworkNeedsCriticalResponse) {
          // First show normal retry UI
          badNetworkRetryPauseTimeout = setTimeout(() => {
            this.handleRetryBadNetworkPauseState();
            badNetworkRetryPauseTimeout = undefined;
          }, pauseFailedTimeoutMs);
        } else {
          // Then show critical UI if we pass through this code path again
          badNetworkCriticalTimeout = setTimeout(() => {
            this.handleBadNetworkCriticalState();
            badNetworkCriticalTimeout = undefined;
          }, pauseFailedTimeoutMs);
        }
      }, skipSpeech ? 1000 : 5000);
    });

    this.networkMonitoringService.logAnalytics("bad_network_pause_state");
  }

  resumeFromBadNetworkPause() {
    const handleContinueFromBadNetworkPause = () => {
      this.props.closeModal(() => {
        this.props.speech.abortSpeech(() => {
          this.setState({ pausedFromBadNetwork: false }, () => {
            // If there is no pending intervention to launch, resume the normal reading experience (restart the timers we cancelled)
            this.resumePhrase();
            const noAudioTimer = window.setTimeout(this.getPauseCheck(this.state.lastProgress, this.onLongPauseDetected, "resumeFromBadNetworkPause").bind(this), 60000);
            this.setState({noAudioTimer});
            this.props.speech.startListening();
            this.networkMonitoringService.logAnalytics("bad_network_continue_pressed");
          });
        });
      });
    }

    this.props.speech.stopListening("resumeFromBadNetworkPause", {
      onFinishCallback: () => {
        this.networkMonitoringService.setAudioMonitoringActive(false);
        this.props.speech.speak({
          textToSpeak: COPY_STRINGS.resume_from_bad_network_speech,
        });
        this.openModal(
          <ErrorModal
            type={getErrorModalTypes().RESUME_FROM_BAD_NETWORK}
            speech={this.props.speech}
            continue={handleContinueFromBadNetworkPause}
          />,
          { logName: "bad_network_resume_state" }
        );
      }
    });

    this.networkMonitoringService.logAnalytics("bad_network_resume_from_bad_network_pause_state");
  }

  handleRetryBadNetworkPauseState() {
    badNetworkNeedsCriticalResponse = true;
    const handleContinueFromRetryModal = () => {
      this.props.speech.abortSpeech(() => {
        this.networkMonitoringService.logAnalytics("bad_network_try_again_from_retry_modal");
        this.pauseFromBadNetwork(
          true // skipSpeech
        );
      });
    }

    this.props.speech.stopListening("badNetworkCritical", {
      onFinishCallback: () => {
        this.openModal(
          <RetryNetworkReconnectModal
            speech={this.props.speech}
            continue={handleContinueFromRetryModal}
          />,
          { logName: "bad_network_retry_state"}
        );
      }
    });
  }

  handleBadNetworkCriticalState() {
    const handleContinueFromCriticalNetwork = () => {
      this.props.speech.abortSpeech(() => {
        this.networkMonitoringService.logAnalytics("bad_network_try_again_from_critical_pressed");
        this.pauseFromBadNetwork(
          true // skipSpeech
        );
      });
    }

    this.props.speech.stopListening("badNetworkCritical", {
      onFinishCallback: () => {
        this.props.speech.speak({
          textToSpeak: COPY_STRINGS.critical_network_speech,
        });
        this.openModal(
          <CriticalNetworkModal
            speech={this.props.speech}
            continue={handleContinueFromCriticalNetwork}
          />,
          { logName: "bad_network_critical_state"}
        );
      }
    });

    this.networkMonitoringService.logAnalytics("bad_network_critical_state");
  }

  render() {
    const shouldHaveNextPageButton = this.props.story && this.props.orfMode && this.props.config.assessmentMode && getUserData().assessmentPageNavEnabled
    const studentReaderContainerClasses = cx({
      studentReaderContainer: true,
      hidden: !this.state.displayContainer,
      asrCheckReadingActivity: this.props.asrStoryID && !this.props.preChecksDone
    })

    return (
      <div className={studentReaderContainerClasses}>
        <ReaderManagerEvents {...{
          readingMode: this.props.config.assessmentMode ? READING_MODES.ASSESSMENT : READING_MODES.TUTOR,
          currentStoryId: this.props.storyId || this.props.asrStoryID,
          currentStory: this.props.story,
          currentPhrase: this.state.currentPhraseIndex,
          currentWordsCorrect: this.calculateWordsCorrect(),
          currentWord: this.state.currentWordIndex,
          currentAccuracy: this.state.accuracy,
          storyStarted: this.state.storyStarted,
          storyInProgress: this.state.storyInProgress,
          minTimeElapsed: this.state.minTimeElapsed,
          storyEnded: this.state.storyEnded,
          phraseEnded: this.state.phraseEnded,
          detections: this.state.detections,
          earlyReaderMode: getEarlyReaderMode(this.props.story)}}/>
        <Reader
          author={this.props.author}
          phrases={this.getCurrentPage()}
          phraseMetaData={this.getCurrentPhraseMetaData()}
          assessmentMode={this.props.config.assessmentMode}
          phraseWordStylingEnabled={!(this.props.orfMode && this.props.config.assessmentMode && getUserData().assessmentPageNavEnabled)}
          repeatInstructions={this.getRepeatInstructions()}
          isNextPhraseVideo={this.isNextPhraseVideo()}
          storyLength={get(this.props, "story.pages.length") || 0}
          storyTitle={this.props.title}
          storyBrand={this.props.brand}
          story={this.props.story}
          isFinal={this.state.isFinal && (this.state.endOfPhrase)}
          scores={this.state.stylingErrors}
          modalOpen={!!this.props.modal}
          endOfPhrase={this.state.endOfPhrase}
          currentWordIndex={this.state.currentWordIndex}
          currentPhraseIndex={this.state.currentPhraseIndex}
          interventionWordIndex={this.state.interventionWordIndex}
          pageIndex={this.props.pageIndex} //TODO: make these arrays one level deeper instead
          setPlacement={this.setPlacement}
          config={this.props.config}
          readyToRead={true}  //###Need to figure out when to trigger this after the "let's read together"
          speech={this.props.speech}
          startPhrase={this.phraseStartCallback}
          pausePhrase={this.pausePhrase}
          resumePhrase={this.resumePhrase}
          phraseTimeout={this.onPhraseTimeout}
          setTextResponse={this.setTextResponse.bind(this)}
          onInstructionEnd={this.resetPhraseTimeout}
          onInstructionStart={this.clearPhraseTimeout}
          sendMessage={this.props.sendMessage}
          onSubmitQuiz={this.onSubmitQuiz}
          listeningStatusEnabled={this.getListeningStatusEnabled()}
          listeningStatusVisible={!this.props.modal && !this.state.repeateAfterMeInterventionInProcess}
          skipIntros={this.props.skipIntros}
          activityIndex={this.props.activityIndex}
          disablePictures={this.shouldDisablePictures()}
          shouldHaveNextPageButton={shouldHaveNextPageButton}
          onNextPageClick={this.onNextPageClick}
          pageNavEnabled={this.state.pageNavEnabled}
          transcript={this.props.transcript}
          isEarlyReader={this.isEarlyReader}
          paused={this.state.paused}
          handleDefaultPauseDetected={this.handleDefaultPauseDetected}
          doneHandlingPause={this.doneHandlingPause}
          advanceOneWord={this.advanceOneWord}
          setDisableInterventionsForPhrase = {this.setDisableInterventionsForPhrase}
          skipWord = {this.skipWord}
          triggerWordIntervention = {this.calculateScoresAndLaunchWordIntervention}
          screenContentOverride={this.state.readerScreenContentOverride}
        />
        {this.getTestControls()}
        {this.state.repeateAfterMeInterventionInProcess &&
          this.getClapInterventionComponent()
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  endingSequence: state.readerManager.contextStates.endingSequence,
});

const mapDispatchToProps = {
  clearEndingSequence,
  logReaderManagerEvents,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withCurrentStoryWordMetadata(ReaderManager)));
